<template>
  <div
    class="container addorder"
    :style="
      (FlodMsg && fullDiscountRule.discountenable == 1) ||
      (FlodMsg && discountrule.discountenable == 1) ||
      (FullGiftMsg && fullgiftrule.actstatus == 1)
        ? { 'padding-bottom': '1.05rem' }
        : {}
    "
  >
    <div class="fraud" v-if="fraud != '' && risktips && arg == ''">
      <img src="../../assets/images/bell.png" />
      <p>{{ fraud }}</p>
      <van-icon @click="risktips = false" name="cross" color="#F96A0E" size="0.13rem" />
    </div>
    <div v-if="addressVal.area && arg == ''" class="my_address" @click="address">
      <img src="../../assets/images/addressicon.png" class="addressicon" />
      <div class="addressML">
        <div class="my_main_address">
          <span>{{ addressVal.name }} {{ addressVal.mobile }}</span>
          <img v-if="addressVal.isdefault === '1'" src="../../assets/images/default.png" />
        </div>
        <div class="address">
          {{ addressVal.area + '' + addressVal.address }}
        </div>
        <p class="f11 color-FC0324 flex-ac" style="margin-top: 0.04rem" v-if="areatemp">
          <van-icon color="#FC0324" name="warning-o" size="0.11rem" />
          地址信息不准确，请尽快更正
        </p>
      </div>
      <van-icon name="arrow" />
    </div>
    <div v-if="!addressVal.area && arg == ''" class="no_address" @click="addaddress">
      <van-icon name="plus" />
      <p>添加收货地址</p>
    </div>

    <div class="cart_pro_list">
      <div v-if="changebuystatus == 1" class="changebuy" style="margin-top: 0" @click="goChangebuy">
        <div class="left">
          <img src="/static/images/changebuy/shopping-icon-bargain-2.png?v=1" />
          <p>购买该商品可参与超值换购</p>
        </div>
        <div class="right">
          <p>去换购</p>
          <van-icon name="arrow" size="0.1rem" color="#1D1E1E" />
        </div>
      </div>
      <div class="list">
        <pro-item
          v-for="(item, index) of list"
          :key="index"
          v-if="
            item.isintellrecommend != 1 &&
            (item.isbirthdaygift != 1 ||
              (item.isbirthdaygift == 1 && paymoney >= birthdaygift_paymoney))
          "
          :productItem="item"
        ></pro-item>
        <div v-if="productgify != null && productgify.hasOwnProperty('goodsinfo')">
          <pro-item
            v-for="(item, index) of [productgify.goodsinfo]"
            :key="list.length + index"
            :productItem="item"
            :isprogift="'1'"
          ></pro-item>
        </div>
        <div v-if="subscribegoodslist.length">
          <pro-item
            v-for="item of subscribegoodslist"
            :key="item.skuid"
            :productItem="item"
          ></pro-item>
        </div>
        <div v-if="buygiftlist && buygiftlist.length > 0">
          <pro-item
            v-for="(item, index) of buygiftlist"
            :key="list.length + index"
            :productItem="item"
            :isprogift="'1'"
          ></pro-item>
        </div>
      </div>
      <div class="numtotal">
        <span>
          共{{
            totalnumshow +
            (buygiftnum ? buygiftnum : 0) +
            (giftnum ? giftnum : 0) -
            (paymoney < birthdaygift_paymoney ? birthdaygifttotalnum : 0)
          }}件
        </span>
        <span v-if="iszg != 1">
          合计：
          <span class="totalprice">¥{{ inittotalmoneyshow }}</span>
        </span>
        <span v-else-if="iszg == 1">
          合计：
          <span class="totalprice">¥139.02</span>
        </span>
      </div>
    </div>
    <div
      class="cart_pro_list changebuylist"
      v-if="exchangestatus == 1 && exchangeitemlist.length > 0"
    >
      <div class="changebuy" style="margin-top: 0">
        <div class="left">
          <img src="/static/images/changebuy/shopping-icon-bargain-1.png?v=1" />
          <p>购买以上商品可参与超值加购</p>
        </div>
      </div>
      <div class="productList list">
        <div class="itemA" v-for="(item, index) in exchangeitemlist" :key="index">
          <div class="labelWrap flex-js-ac">
            <div class="tips" :style="exchangeitemlist.length > 0 ? { width: '100%' } : {}">
              <p>{{ item.tipLable }}</p>
              <p>{{ item.tipTime }}</p>
            </div>
          </div>
          <div class="itemWrap" v-for="(itemB, indexB) in item.changebuylist" :key="item.skuid">
            <div class="item flex-ac">
              <van-checkbox
                v-model="itemB.ischoose"
                checked-color="#FC0324"
                @click="choice(index, indexB)"
              ></van-checkbox>
              <img :src="itemB.img_path" @click.stop="godetail(itemB)" />
              <div class="rightBox" @click.stop="godetail(itemB)">
                <p class="name over-ell-1">{{ itemB.name }}</p>
                <p class="oldPrice">原价¥{{ itemB.cost_price }}</p>
                <div class="flex-js-ac">
                  <p class="currentPrice">
                    <span class="lable">加购价¥</span>
                    <span class="price">{{ itemB.changebuy_price }}</span>
                  </p>
                  <div class="stepBox flex-js-ac">
                    <div
                      :class="[itemB.num <= 1 ? 'can' : '', 'subtract stepBtn']"
                      @click.stop="addToCart(0, index, indexB, itemB)"
                    ></div>
                    <div class="num">{{ itemB.num }}</div>
                    <div
                      :class="[itemB.num < itemB.canbuycnt ? 'can' : '', 'add stepBtn']"
                      @click.stop="addToCart(1, index, indexB, itemB)"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ysale" v-if="itemB.presaletime" style="padding-left: 0.1rem">
              <van-tag color="#FEE9E6" text-color="#F12A0E">预售</van-tag>
              <img src="../../assets/images/presell.png" />
              <div class="txt">预售发货时间：{{ itemB.presaletime }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="additional">
      <van-cell-group>
        <van-cell title="运费" :value="'¥' + freight" value-class="txt" />
        <van-cell
          v-if="fullMinusRules.actStatus == 1 && fullminusmoney - extraMinusMoney > 0"
          :value="'-¥' + parseFloat(fullminusmoney - extraMinusMoney).toFixed(2)"
          value-class="txt color-FC0324"
        >
          <template #title>
            <span class="custom-title">全场满减</span>
            <van-tag class="tag_danger" type="danger">{{ fullMinusRules.actLabel }}</van-tag>
          </template>
        </van-cell>
        <van-cell
          v-if="fullMinusRules.actStatus == 1 && extraMinusMoney > 0"
          :value="'-¥' + parseFloat(extraMinusMoney).toFixed(2)"
          value-class="txt color-FC0324"
        >
          <template #title>
            <span class="custom-title color-FC0324">返场优惠</span>
            <van-tag class="tag_danger" type="danger">
              每满{{ parseFloat(fullMinusRules.fullMoney) }}再减{{
                parseFloat(fullMinusRules.extraMinusMoney)
              }}
            </van-tag>
          </template>
        </van-cell>
        <van-cell
          :value="'-¥' + parseFloat(fullDiscountRule.fullDiscountmoney).toFixed(2)"
          :title="fullDiscountRule.actlabel"
          v-if="parseFloat(fullDiscountRule.fullDiscountmoney) > 0"
          value-class="txt"
        />
        <van-cell
          :value="'-¥' + parseFloat(directReductionmoney).toFixed(2)"
          title="直降"
          v-if="parseFloat(directReductionmoney) > 0"
          value-class="txt"
        />
        <van-cell
          :value="'-¥' + parseFloat(depositmoney).toFixed(2)"
          title="定金翻倍(含定金)"
          v-if="parseFloat(depositmoney) > 0"
          value-class="txt"
        />
        <van-cell
          :value="productcount > 0 && producttitle != '' ? producttitle : '不使用'"
          @click="showProduct"
          class="cell"
          is-link
          title="产品劵"
          v-if="productcount > 0 && iszg != 1 && yl != 1 && ylact != 1 && ms != 1"
          value-class="txt"
        />
        <van-cell
          :value="'-¥' + parseFloat(morediscountsmoney).toFixed(2)"
          @click="showActDesc('morediscounts')"
          class="cell"
          is-link
          title="多件立减"
          v-if="parseFloat(morediscountsmoney) > 0 && iszg != 1 && yl != 1 && ylact != 1"
          value-class="txt"
        />
        <van-cell
          :value="discountrule.name + ' -¥' + parseFloat(discountmoney).toFixed(2)"
          @click="showActDesc"
          class="cell"
          is-link
          title="活动"
          v-if="parseFloat(discountmoney) > 0 && iszg != 1 && yl != 1 && ylact != 1"
          value-class="txt"
        />
        <van-cell
          title="活动"
          value="折扣专区"
          value-class="txt"
          class="cell"
          v-if="ishalfprice == 1 && iszg != 1 && yl != 1 && ylact != 1"
        />
        <van-cell
          class="integral cell"
          label-class="integralLab"
          title-class="integralTitle"
          v-if="usablecount > 0 && iszg != 1 && yl != 1 && ylact != 1 && ms != 1"
          value-class="integralVal"
        >
          <template slot="title">
            <div :class="{ grayCoupon: !couponChecked, integralTotal: true }" @click="showCoupon">
              <span class="custom-title">现金券</span>
              <b style="margin-left: 0.36rem" v-if="couponChecked">
                {{ usablecount > 0 && couponstitle != '' ? couponstitle : '选择现金券' }}
              </b>
              <b style="margin-left: 0.36rem" v-else>
                {{ couponstitle != '' ? couponstitle : '选择现金券' }}
              </b>
              <van-icon name="arrow" size="0.12rem" v-if="couponChecked" />
            </div>
          </template>
          <!--          <template slot="label"></template>-->
          <van-switch
            :disabled="usablecount <= 0 && couponstitle == ''"
            @change="switchCouponFn"
            size="0.2rem"
            v-model="couponChecked"
          />
        </van-cell>
        <van-cell
          class="integral cell"
          label-class="integralLab"
          title-class="integralTitle"
          v-if="usablecount <= 0 && iszg != 1 && yl != 1 && ylact != 1 && ms != 1"
          value-class="integralVal"
        >
          <template slot="title">
            <div @click="showCoupon" class="integralTotal grayCoupon">
              <span class="custom-title">现金券</span>
            </div>
          </template>
          <div class="integralTotal grayCoupon" style="display: block">
            <b>{{ nocoupontext }}</b>
          </div>
        </van-cell>
        <!--        <van-cell title="现金券" :value="discountrule.name + ' -¥' + parseFloat(discountmoney).toFixed(2)" value-class="txt" class="cell"  v-if="parseFloat(discountmoney)>0"/>-->
        <van-cell
          class="integral"
          label-class="integralLab"
          title-class="integralTitle"
          v-if="iszg != 1 && yl != 1 && ylact != 1 && ms != 1"
          value-class="integralVal"
        >
          <!--        积分规则修改废弃(勿删)-->
          <!--          <template slot="title">-->
          <!--            <div class="integralTotal">-->
          <!--              <span class="custom-title">使用积分</span>-->
          <!--              <img src="../../assets/images/integralrule.png" @click="integralRule">-->
          <!--              <b v-if="integerlist && integerlist.length <= 0">积分不足以抵扣</b>-->
          <!--              <b v-else>共{{totalIntegral}}</b>-->
          <!--            </div>-->
          <!--          </template>-->
          <!--          <template slot="label" v-if="integerlist && integerlist.length > 0">-->
          <!--            <div class="integralTotal" v-if="integerlist && integerlist.length > 0">-->
          <!--              <b>使用{{parseInt(useIntegral)}}，抵扣￥{{parseFloat(moneyByIntegral).toFixed(2)}}&nbsp;<i v-if="integralChecked" @click="showIntegral">修改</i></b>-->
          <!--            </div>-->
          <!--          </template>-->
          <!--   over    -->
          <!--          金币商城v2，暂时废弃-->
          <template slot="title">
            <div :class="{ grayCoupon: !integralChecked, integralTotal: true }">
              <span class="custom-title">金币</span>
              <img src="../../assets/images/integralrule.png" @click="integralRule" />
              <b v-if="integerlist && integerlist.length > 0 && useIntegral > 0">
                <b>金币{{ parseInt(useIntegral) }}</b>
                <b>可抵扣{{ parseFloat(moneyByIntegral).toFixed(2) }}元</b>
              </b>
            </div>
          </template>
          <template slot="label" v-if="ispreferentialmutex == 1">
            <b>
              <i>现金券抵扣、金币抵扣，二选一</i>
            </b>
          </template>
          <!--          <template slot="label" v-if="integerlist && integerlist.length > 0">-->
          <!--            <div :class="{'grayCoupon' : !integralChecked, 'integralTotal': true}" v-if="integerlist && integerlist.length > 0">-->
          <!--              <b>可抵扣<i>{{parseFloat(moneyByIntegral).toFixed(2)}}元</i>-->
          <!--&lt;!&ndash;                <i v-if="integralChecked" @click="showIntegral">修改</i>&ndash;&gt;-->
          <!--              </b>-->
          <!--            </div>-->
          <!--          </template>-->
          <!--          over-->
          <div
            :class="{ grayCoupon: !integralChecked, integralTotal: true }"
            style="display: block"
            v-if="useIntegral <= 0"
          >
            <b>金币不可用</b>
          </div>
          <van-switch
            :disabled="integerlist && integerlist.length <= 0"
            @change="switchIntegralFn"
            size="0.2rem"
            v-if="useIntegral > 0"
            v-model="integralChecked"
          />
        </van-cell>
        <van-field
          class="field"
          maxlength="45"
          v-model="remark"
          label="订单备注"
          placeholder="选填，最多45字，请先和客服协商一致"
        />
      </van-cell-group>
    </div>
    <div class="cart_pro_list changebuylist recommenditemlist" v-if="recommenditemlist.length > 0">
      <div class="title f0 flex-ac">
        <img src="/static/images/recommend/group@2x.png" />
        <span class="f12">你可能还会喜欢</span>
        <van-icon
          class="close"
          name="cross"
          color="#B3B3B3"
          size="0.14rem"
          @click="closeRecommend(0, 0, recommenditemlist[0])"
        />
      </div>
      <div class="productList list" style="padding-bottom: 0.05rem">
        <div class="itemA" v-for="(item, index) in recommenditemlist" :key="item.skuid">
          <div class="itemWrap">
            <div class="item flex-ac">
              <img :src="item.img_path" @click.stop="godetail(item, 'recommend')" />
              <div class="rightBox" @click.stop="godetail(item, 'recommend')">
                <p class="name over-ell-2">{{ item.name }}</p>
                <p class="f11 over-ell-2" style="color: #6c6c6c; margin-top: 0.02rem">
                  {{ item.spec }}
                </p>
                <div class="flex-js-ac recommendPrice">
                  <p class="currentPrice">
                    <span class="label">¥</span>
                    <span class="price">{{ item.price }}</span>
                    <span class="oldPrice">¥{{ item.cost_price }}</span>
                  </p>
                  <div v-if="item.num > 0" class="stepBox flex-js-ac">
                    <div
                      :class="['subtract stepBtn']"
                      @click.stop="recommendAddToCart(0, index, item)"
                    ></div>
                    <div class="num">{{ item.num }}</div>
                    <div
                      :class="[
                        parseInt(item.num) < parseInt(item.canbuycnt) ? 'can' : '',
                        'add stepBtn'
                      ]"
                      @click.stop="recommendAddToCart(1, index, item)"
                    ></div>
                  </div>
                  <div class="stepBox0 f12" v-else @click.stop="recommendAddToCart(1, index, item)">
                    一键购买
                  </div>
                </div>
              </div>
            </div>
            <div class="ysale" v-if="item.presaletime" style="padding-left: 0.1rem">
              <van-tag color="#FEE9E6" text-color="#F12A0E">预售</van-tag>
              <img src="../../assets/images/presell.png" />
              <div class="txt">预售发货时间：{{ item.presaletime }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    折上折-->
    <div
      class="additemMsg footerIOS"
      @click="goflod('flod')"
      v-if="FlodMsg && discountrule.discountenable == 1"
    >
      <div class="msg">
        <img src="../../assets/images/surprised.png" />
        <div class="txt" v-html="FlodMsg"></div>
      </div>
      <div class="btn" v-if="parseInt(goodsnum) < parseInt(discountrule.discountlist[0].itemnum)">
        去凑单>
      </div>
    </div>
    <!--    限时折扣-->
    <div
      class="additemMsg footerIOS"
      @click="goflod('fulldiscount')"
      v-if="FlodMsg && fullDiscountRule.discountenable == 1"
    >
      <div class="msg">
        <img src="../../assets/images/surprised.png" />
        <div class="txt" v-html="FlodMsg"></div>
      </div>
      <div class="btn" v-if="parseInt(goodsnum) < parseInt(fullDiscountRule.rulelist[0].num)">
        去凑单>
      </div>
    </div>
    <!--    满赠-->
    <div
      class="additemMsg footerIOS"
      @click="gofullgift"
      v-if="FullGiftMsg && fullgiftrule.actstatus == 1 && fullgiftrule.isaddon == 1"
    >
      <div class="msg">
        <img src="../../assets/images/surprised.png" />
        <div class="txt" v-html="FullGiftMsg"></div>
      </div>
      <div
        class="btn"
        v-if="parseFloat(currentfullgiftmoney) < parseFloat(fullgiftrule.rulelist[0].allmoney)"
      >
        去凑单>
      </div>
    </div>
    <div class="sub_bar footerIOS">
      <div class="itemtxt">
        需付款：
        <span class="xprice">
          <sub>¥</sub>
          <b
            v-text="
              !isNaN(pay_money) ? String(pay_money).slice(0, String(pay_money).indexOf('.')) : '0'
            "
          ></b>
          <sup
            v-text="
              !isNaN(pay_money)
                ? String(pay_money).slice(String(pay_money).indexOf('.'), String(pay_money).length)
                : '.00'
            "
          ></sup>
        </span>
      </div>
      <div class="btton" @click="goNext">
        {{ $route.query.acttype == 'hc_welfare' ? '立即自提' : '提交订单' }}
      </div>
    </div>
    <van-action-sheet v-model="showcoupon" title="选择现金券" show-action @cancel="closeCoupon">
      <div class="coupon">
        <div class="coupon_item" v-for="(item, index) in usecouponlist" :key="item.id">
          <div class="coupon_info" :class="{ isspecialbackground: item.isspecial == 1 }">
            <div class="f1">
              <span>{{ parseInt(item.price) }}</span>
              <span>{{ item.couponname }}</span>
            </div>
            <div class="f2">
              <span>{{ item.gettype }}</span>
              <span>
                <label>
                  {{
                    item.starttime.replace(/-/g, '.') + '-' + item.invalidtime.replace(/-/g, '.')
                  }}
                </label>
                <div
                  @click="chooseCoupon(index)"
                  class="f3 active closeChoose"
                  v-if="item.isChoose == true"
                >
                  取消选择
                </div>
                <div class="f3" v-else @click="chooseCoupon(index)">选择</div>
              </span>
            </div>
            <div class="coupon_tit">
              <div class="tit_info" v-if="item.details != ''">
                <div class="tit">详细信息</div>
                <van-icon
                  name="arrow-down"
                  @click="showCouponDesc(index, 'coupon')"
                  v-if="!item.isShowDesc"
                />
                <van-icon
                  name="arrow-up"
                  @click="showCouponDesc(index, 'coupon')"
                  v-if="item.isShowDesc"
                />
              </div>
            </div>
          </div>
          <div class="coupon_desc" v-if="item.isShowDesc">
            {{ item.details }}
          </div>
        </div>
        <div
          class="coupon_item nocoupon_item"
          v-for="(noItem, noIndex) in nousercouponlist"
          :key="parseInt('1' + noIndex)"
        >
          <div class="coupon_info">
            <div class="f1">
              <span>{{ parseInt(noItem.price) }}</span>
              <span>{{ noItem.couponname }}</span>
            </div>
            <div class="f2">
              <span>{{ noItem.gettype }}</span>
              <span>
                <label>{{ noItem.starttime + '-' + noItem.invalidtime }}</label>
              </span>
            </div>
            <div class="coupon_tit">
              <div class="tit_info" v-if="noItem.details != ''">
                <div class="tit">详细信息</div>
                <van-icon
                  name="arrow-down"
                  @click="showCouponDesc(noIndex, 'nocoupon')"
                  v-if="!noItem.isShowDesc"
                />
                <van-icon
                  name="arrow-up"
                  @click="showCouponDesc(noIndex, 'nocoupon')"
                  v-if="noItem.isShowDesc"
                />
              </div>
            </div>
          </div>
          <div class="coupon_desc" v-if="noItem.isShowDesc">
            {{ noItem.details }}
          </div>
        </div>
        <div class="coupon_btn" v-if="couponBtn" @click="comfrimCoupon">
          确认{{ '可省¥' + couponPrice + '元' }}
        </div>
      </div>
    </van-action-sheet>
    <van-action-sheet v-model="showproduct" title="选择产品劵" show-action @cancel="closeProduct">
      <div class="coupon">
        <div class="coupon_item product_item" v-for="(item, index) in productlist" :key="index">
          <div class="coupon_info product_info">
            <div class="f1 productf1">
              <img class="product" v-lazy="item.goodsinfo.img_path" />
              <!--              <span>{{parseInt(item.price)}}</span>-->
              <!--              <span>{{item.couponname}}</span>-->
            </div>
            <div class="f2">
              <span>{{ item.name }}</span>
              <span>
                <label>
                  {{ item.begin_time.replace(/-/g, '.') + '-' + item.end_time.replace(/-/g, '.') }}
                </label>
                <div
                  class="f3 active closeChoose"
                  v-if="item.isChoose == true"
                  @click="chooseProduct(index)"
                >
                  已选择
                </div>
                <div class="f3" v-else @click="chooseProduct(index)">选择</div>
              </span>
            </div>
            <div class="coupon_tit">
              <div class="tit_info" v-if="item.content != ''">
                <div class="tit">详细信息</div>
                <van-icon
                  name="arrow-down"
                  @click="showProductDesc(index)"
                  v-if="!item.isShowDesc"
                />
                <van-icon name="arrow-up" @click="showProductDesc(index)" v-if="item.isShowDesc" />
              </div>
            </div>
          </div>
          <div class="coupon_desc" v-if="item.isShowDesc">
            {{ item.content }}
          </div>
        </div>
        <div class="coupon_btn" v-if="productBtn" @click="comfrimProduct">确认</div>
      </div>
    </van-action-sheet>
    <!--        积分规则修改废弃(勿删)
    <van-action-sheet v-model="showintegral" class="inegralAction" title="使用积分" @cancel="closeIntegral">
      <div class="coupon integralPopUp">
        <van-radio-group v-model="radio">
          <van-radio v-for="(item, index) of integerlist" :key="parseInt('2' + index)" :name="index" checked-color="#FC0324">
            <b>使用{{item.limitinteger}}积分，抵扣￥{{parseFloat(item.integermoney).toFixed(2)}}</b>
            <i></i>
          </van-radio>
        </van-radio-group>
        <van-radio-group v-model="radio1" disabled style="margin-top: 0.17rem">
          <van-radio v-for="(item, index) of nouseIntegerlist" :key="parseInt('3' + index)" :name="index" checked-color="#FC0324">
            <b>使用{{item.limitinteger}}积分，抵扣￥{{parseFloat(item.integermoney).toFixed(2)}}</b>
            <i>不可选择</i>
          </van-radio>
        </van-radio-group>
        <div class="coupon_btn" @click="comfrimIntegral">
          确认
        </div>
      </div>
    </van-action-sheet>
   over    -->
    <!--活动服务-->
    <van-action-sheet v-model="showaction" title="活动介绍">
      <div class="van-action_model">
        <div class="van-item" v-for="(item, index) in msglist" :key="index">
          <div v-if="!item.desclist">
            <div class="tit">
              <van-tag color="#FEE9E6" text-color="#F12A0E">{{ item.actlabel }}</van-tag>
              {{ item.name }}
            </div>
            <div class="con">
              {{ item.desc }}
            </div>
          </div>
          <div v-else>
            <div class="tit">
              <van-tag color="#FEE9E6" text-color="#F12A0E">{{ item.actlabel }}</van-tag>
              <div v-for="(itemSon, indexSon) of item.desclist" :key="indexSon">
                <div class="con">
                  {{ itemSon.name }}
                  <br />
                  {{ itemSon.discountdesc }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn">
          <van-button round type="danger" class="vanbtn" @click="showaction = false">
            确定
          </van-button>
        </div>
      </div>
    </van-action-sheet>

    <!--    <van-dialog
      v-model="showflodmsg"
      class="van-flod-dialog"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="floddialog">再选购{{flodnum}}件,可享受{{flodtxt}}折优惠</div>
      <div class="btn">
        <van-button round plain hairline class="van-btn-01" @click="handleAddOrder">不用了</van-button>
        <van-button round type="danger" class="van-btn-02" @click="handleCancelFlod">再选一件</van-button>
      </div>
    </van-dialog>
 -->
    <van-dialog
      v-model="showsubscribegoodsmsg"
      class="van-flod-dialog"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="floddialog" v-html="subscribegoodsrule.tips"></div>
      <div class="btn">
        <van-button round plain hairline class="van-btn-01" @click="handleShowsubscribegoodsOrder">
          放弃
        </van-button>
        <van-button round type="danger" class="van-btn-02" @click="handleCancelShowsubscribegoods">
          去凑单
        </van-button>
      </div>
    </van-dialog>
    <van-dialog
      v-model="showFiveHundmsg"
      class="van-flod-dialog"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="floddialog">{{ couponstips.tips }}</div>
      <div class="btn">
        <van-button round plain hairline class="van-btn-01" @click="handleAddFiveHundOrder">
          不用了
        </van-button>
        <van-button round type="danger" class="van-btn-02" @click="handleCancelFiveHund">
          去凑单
        </van-button>
      </div>
    </van-dialog>
    <van-dialog
      v-model="showEightHundmsg"
      class="van-flod-dialog"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="floddialog">{{ drawprizetips.tips }}</div>
      <div class="btn">
        <van-button round plain hairline class="van-btn-01" @click="handleAddEightHundOrder">
          不用了
        </van-button>
        <van-button round type="danger" class="van-btn-02" @click="handleCancelEightHund">
          去凑单
        </van-button>
      </div>
    </van-dialog>
    <van-dialog
      v-model="showaddress"
      class="van-flod-dialog van-address-dialog"
      title="确认信息"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="addressdialog">
        <ul>
          <li class="flex">
            <span>收货人：</span>
            <p class="flex-1">{{ addressVal.name }}</p>
          </li>
          <li class="flex">
            <span>手机号：</span>
            <p class="flex-1">{{ addressVal.mobile }}</p>
          </li>
          <li class="flex">
            <span>收货地址：</span>
            <p class="over-ell-2 flex-1">
              {{ addressVal.area + '' + addressVal.address }}
            </p>
          </li>
          <li class="flex upd" v-if="areatemp">
            <span></span>
            <div class="flex-1">
              <p class="f15">地区推荐更正为：</p>
              <p class="f15 color-FC0324">{{ areatemp + addresstemp }}</p>
              <div class="flex-js-ac" style="margin-top: 0.04rem">
                <p></p>
                <van-button
                  @click="editaddressFn"
                  class="updbtn"
                  color="#FC0324"
                  plain
                  round
                  size="mini"
                  type="primary"
                >
                  &nbsp;&nbsp;&nbsp;&nbsp;更正&nbsp;&nbsp;&nbsp;&nbsp;
                </van-button>
              </div>
            </div>
          </li>
          <li class="flex">
            <span>商品数量：</span>
            <p class="num flex-1">
              {{
                totalnum +
                (buygiftnum ? buygiftnum : 0) +
                (giftnum ? giftnum : 0) -
                (paymoney < birthdaygift_paymoney ? birthdaygifttotalnum : 0)
              }}
            </p>
          </li>
          <li class="flex">
            <span>需付款：</span>
            <p class="money flex-1">¥{{ pay_money }}</p>
          </li>
        </ul>
        <p class="f12 color-FC0324" style="margin-top: 0.1rem" v-if="isareacode == 0">
          为保证包裹派件正确，请重新更正地址
        </p>
      </div>
      <div class="btn areacodebtn" v-if="isareacode == 0">
        <van-button round type="danger" class="van-btn-02" @click="handleEditorAddress">
          修改
        </van-button>
      </div>
      <div class="btn" v-else>
        <van-button round plain hairline class="van-btn-01" @click="handleAddress">修改</van-button>
        <van-button round type="danger" class="van-btn-02" @click="handlePay">
          {{ $route.query.acttype == 'hc_welfare' ? '去自提' : '去支付' }}
        </van-button>
      </div>
    </van-dialog>
    <van-dialog
      :show-cancel-button="false"
      :show-confirm-button="false"
      class="van-flod-dialog temp_dialog"
      v-model="showPayTemp"
    >
      <div class="floddialog">
        尊敬的用户，因近日微信支付正在调试，请前往【创客云商商城APP】使用支付宝支付~
        <br />
        您的订单已在创客云商商城APP“我的订单>>待支付订单”等你哦！
      </div>
      <div class="btn">
        <van-button @click="showPayTemp = false" class="van-btn-01" hairline plain round>
          取消
        </van-button>
        <van-button class="van-btn-02" round type="danger">
          前往APP商城
          <wx-open-launch-app
            @error="error"
            @launch="launch"
            appid="wx997fa1bb80ec9278"
            extinfo="your-extinfo"
            id="launch-btn"
          >
            <script type="text/wxtag-template">
              <style>.btn {
                      color: #ffffff;
                      font-size: 14px;
                      background: transparent;
                      border-width: 0;
                      line-height: 32px;
                      height: 32px;
                      }</style>
                      <button class="btn"></button>
            </script>
          </wx-open-launch-app>
        </van-button>
      </div>
    </van-dialog>
    <van-overlay :show="showtemp" z-index="3000"></van-overlay>
    <div class="sharecontainer" v-if="showtemp === true">
      <img src="../../assets/images/showtemp.png" />
      <van-button @click="showtemp = false" class="know" plain round type="danger">
        我知道了
      </van-button>
    </div>
    <van-dialog
      v-model="ismobile"
      title="温馨提示"
      :before-close="(action, done) => done(false)"
      @confirm="confirm"
      @cancel="cancel"
      show-cancel-button
      cancel-button-color="#fc0324"
      cancel-button-text="放弃福利"
      class="signin_button_alert collect_button_alert"
    >
      <p class="f15" style="color: #444; padding: 0 0.23rem 0.1rem">
        买{{ is_50vipentranceName }}会送您升级成为50VIP的权利，请输入您要成为50VIP的手机号码
      </p>
      <ul>
        <li class="flex">
          <input type="tel" v-model="mobile" placeholder="请输入手机号" />
          <img class="del-btn" src="/static/wx/img/close3.png" v-if="mobile" @click="mobile = ''" />
        </li>
        <li class="flex">
          <input type="text" v-model="code" placeholder="图片验证码" />
          <img class="del-btn" src="/static/wx/img/close3.png" v-if="code" @click="code = ''" />
          <img ref="codeImg" :src="codeImg" alt="" @click="getCodeImg" />
        </li>
        <li class="flex">
          <input type="tel" v-model="sms" placeholder="验证码" />
          <img class="del-btn" src="/static/wx/img/close3.png" v-if="sms" @click="sms = ''" />
          <i class="countdown" v-if="time == 60" @click="sendAgain">获取验证码</i>
          <i class="countdown" v-else-if="time != 0">{{ time }}s后重新发送</i>
          <i class="countdown sendAgain" v-else-if="time == 0" @click="sendAgain">重新发送</i>
        </li>
      </ul>
    </van-dialog>
  </div>
</template>

<script>
import proItem from '../common/cart_pro_item'
import Vue from 'vue'
import '../../../static/wx/css/mobilePop.css'
import {
  appid,
  isWeixin,
  fenxiang,
  isApp,
  encryption,
  clone,
  downloadshoppath,
  downloadpath,
  basepath,
  random_string,
  discernFunc
} from '../../assets/common/js/config'
import { Switch, Tag } from 'vant'
Vue.config.ignoredElements = ['wx-open-launch-app']

Vue.use(Switch)
export default {
  name: 'addOrder',
  data: function () {
    return {
      iszg: this.$route.query.iszg,
      yl: this.$route.query.yl || 0, // 引流活动
      ylact: this.$route.query.ylact || 0, // 引流活动专区
      ms: this.$route.query.ms || 0, // 秒杀活动
      lb: this.$route.query.lb || 0, // 钜惠店主.创客 礼包活动
      ann: this.$route.query.ann || 0, // 周年庆活动
      anncc: this.$route.query.anncc || 0, // 周年庆29.9
      showaddress: false,
      // showflodmsg: false,
      showFiveHundmsg: false,
      showEightHundmsg: false,
      showaction: false,
      discountaddress: 0,
      msglist: [],
      value: 1,
      radio: 0,
      remark: '',
      radio1: null,
      list: [],
      listtemp: '', // 商品数据临时存储
      addressList: [],
      fraud: '',
      risktips: true,
      itemids: [], // 可使用券商品集合，用于匹配现金券规则
      totalmoney: 0, // 合计金额不参与定金计算
      inittotalmoneyshow: '0.00', // 合计金额显示
      inittotalmoney: 0, // 合计金额（参与定金计算）最终合计金额
      mtacttotalmoney: 0, // N件打包活动 合计金额
      totalprice: 0, // 实付金额
      pay_money: '0.00', // 最终实付金额
      totalnum: 0, // 商品数量
      totalnumshow: 0, // 合计商品数量显示
      totalnumtemp: 0, // 商品数量临时存储
      objitem: '', // 商品重组
      couponlistrule: [],
      goodscouponrule: [],
      showcoupon: false,
      couponBtn: false,
      addressVal: {},
      usablecount: 0,
      couponChecked: false,
      localCoupon: null,
      couponlist: [], // 优惠券列表
      usecouponlist: [], // 可用优惠券
      nousercouponlist: [], // 不可用优惠券
      chooseUsecouponIndex: null,
      couponPrice: 0,
      couponstitle: '',
      nocoupontext: '',
      productcount: 0,
      producttitle: '',
      showproduct: false,
      productBtn: false,
      productlist: [],
      productgify: null,
      productPrice: 0,
      chooseProductIndex: null,
      jfchecked: false,
      // 积分预埋开始
      integerrule: null,
      integralChecked: false,
      // showintegral: false,
      isintegral: '',
      useIntegral: '', // 可用积分
      totalIntegral: '', // 总积分
      interate: '', // 积分占比
      integralrule: [],
      integerlist: [], // 可用积分
      integerAllList: [], // 积分
      nouseIntegerlist: [], // 不可用积分
      moneyByIntegral: '', // 积分抵扣金额
      // 积分预埋结束
      ispreferentialmutex: 0, // 现金券与积分使用互斥
      useintegralitemjson: '', // 后台用
      // 折上折
      showFlod: false,
      goodsnum: 0,
      FlodMsg: '',
      discountrule: {},
      couponstips: {},
      drawprizetips: {},
      isdiscount: 0,
      currentdiscountIndex: -1,
      currentdiscountdata: 0,
      flodnum: 0,
      flodtxt: '',
      FullGiftMsg: '',
      fullgiftrule: {},
      currentfullgiftmoney: 0,
      fullgiftrulenew: [], // 满赠
      fullgift: {}, // 满赠
      giftmoney: 0, // 满赠商品加购总价
      giftactid: '', // 满赠ID
      giftitem: '', // 满赠商品skuid
      giftnum: 0, // 满赠商品数量
      isgiftpop: 0, // 是否弹出按钮
      halfprice: {},
      ishalfprice: 0, // 5折专区标识
      freight: 0,
      orderid: null,
      jumplink: '',
      isSwitch: null,
      arg: isApp(),
      changebuystatus: 0, // 换购活动状态
      exchangestatus: 0, // 加购活动状态
      depositmoney: 0,
      showPayTemp: false,
      showtemp: false,
      exchangeitemlist: [], // 订单加购list
      exchangeitemlisttemp: '', // 订单加购list数据临时存储
      exchangechooseitemlist: [], // 已选中的加购商品
      exchangetotalNumber: 0,
      exchangemaxcanbuycnt: 0,
      exchangetotalmoney: 0,
      exchange_paymoney: 0,
      directReductionmoney: 0,
      ischeckaddress: false,
      fullDiscountRule: {}, // 限时折扣 满N件打XX折活动
      recommenditemlist: [], // 智能推荐
      recommendmoney: 0, // 智能推荐金额
      recommendnumber: 0, // 智能推荐数量
      couponmoney: 0, // 现金券抵扣金额
      integralmoney: 0, // 金币抵扣金额
      birthdaygift_paymoney: 0, // 会员中心权益-生日盲盒门槛金额
      birthdaygifttotalnum: 0, // 会员中心权益-生日盲盒数量
      morediscounts: {}, // n件立减
      morediscountsmoney: 0, // n件立减金额
      fullMinusRules: {}, // 满减活动规则
      fullminusmoney: 0, // 满减活动金额 + 满减返场活动金额
      extraMinusMoney: 0, // 满减返场活动金额
      fullminustotalmoney: 0, // 参与满减活动的商品总金额
      fullMinusMsg: '', // 满减活动描述
      is_50vipentrance: 0,
      is_50vipentranceName: '',
      ismobile: false,
      mobile: '',
      code: '',
      sms: '',
      codeImg: null, // 图片验证码
      timeout: null, // 事件随机码
      imgCodeValue: '', // 图片验证码-值
      time: 60,
      isareacode: -1,
      showsubscribegoodsmsg: false, // 38预约活动-弹窗提示
      subscribegoodsrule: {}, // 38预约活动-规则
      subscribegoodslist: [], // 38预约活动商品
      subscribegoods_totalmoney: 0, // 38预约活动-参与活动商品总金额
      buygiftrule: {}, // 买赠活动
      buygiftlist: [], // 买赠活动已选赠品页面显示集合
      buygiftlist_submit: [], // 买赠活动已选赠品提交下单参数
      buygiftnum: 0, // 买赠商品数量
      areatemp: '',
      areaidtemp: '',
      addresstemp: ''
    }
  },
  components: {
    proItem,
    [Tag.name]: Tag
  },
  computed: {
    currentdiscount: function () {
      var that = this
      var currentdiscount = 1
      var goodsnum = 0
      that.list.forEach(function (item) {
        if (item.isdiscount == 1) {
          goodsnum += parseInt(item.num)
        }
      })
      if (that.discountrule && that.discountrule.discountenable == 1) {
        var discountlist = that.discountrule.discountlist
        if (parseInt(goodsnum) == 0) {
          currentdiscount = 1
        } else if (parseInt(goodsnum) >= parseInt(discountlist[0].itemnum)) {
          let discount = discountlist[0].discount
          currentdiscount = discount
        } else {
          try {
            discountlist.forEach(function (item, index) {
              if (parseInt(goodsnum) >= parseInt(item.itemnum)) {
                let discount1 = item.discount
                currentdiscount = discount1
                throw new Error()
              }
            })
          } catch (e) {
            return currentdiscount
          }
        }
      }
      return currentdiscount
    },
    discountmoney: function () {
      this.discountFn()
      var that = this,
        money = 0,
        money1 = 0,
        goodsnum = 0,
        totalmoney = 0
      that.list.forEach(function (item) {
        if (item.isgift != 1 && item.isgiftproduct != 1) {
          money += parseFloat(item.price) * parseInt(item.num)
        }
        if (item.isdiscount == 1) {
          goodsnum += parseInt(item.num)
          money1 += parseFloat(item.price) * parseInt(item.num)
        }
        if (item.ischangebuy == 1 || item.isgiftproduct == 1) {
          totalmoney += parseFloat(item.price) * parseInt(item.num)
        }
      })
      if (that.discountrule && that.discountrule.discountenable == 1) {
        var discountlist = that.discountrule.discountlist
        try {
          discountlist.forEach(function (item, index) {
            if (parseInt(goodsnum) >= parseInt(item.itemnum)) {
              that.currentdiscountIndex = index
              throw new Error()
            }
          })
        } catch (e) {}
      }
      // var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      if (money1 > 0 && that.currentdiscountdata > 0) {
        return money1 * (1 - that.currentdiscountdata)
      } else {
        return 0
      }
      // return parseFloat(money - parseFloat(shopConfirmResult.totalmoney + totalmoney).toFixed(2)).toFixed(2) || 0
    },
    itemidsAddress: function () {
      var that = this
      if (that.addressVal && JSON.stringify(that.addressVal) != '{}') {
        var itemids = [],
          buynum = []
        var freights = 0
        freightsFn(that.list, 0)
        freightsFn(that.exchangechooseitemlist, 1)
        freightsFn(that.buygiftlist, 1)
        function freightsFn(list, type) {
          list.forEach(function (item, index) {
            itemids.push(item.skuid ? item.skuid : item.itemid)
            buynum.push(item.num)
            if (type == 0) {
              if (item.ispayfreight == 1) {
                freights = 1
              } else if (
                that.$route.query.yl == 1 ||
                that.$route.query.ms == 1 ||
                that.$route.query.ylact == 1
              ) {
                freights = 1
              }
            } else {
              freights = 1
            }
          })
        }
        if (freights == 1) {
          return itemids.join(',') + '|' + that.addressVal.id + '|' + buynum.join(',')
        }
      }
      return ''
    },
    paymoney: function () {
      // 实付金额 +活动抵扣 不含运费 用于活动折扣计算
      var m = parseFloat(this.totalprice) + parseFloat(this.giftmoney)
      if (
        parseFloat(
          m - this.morediscountsmoney - this.exchangetotalmoney - this.fullminusmoney
        ).toFixed(2) < parseFloat(this.exchange_paymoney)
      ) {
        this.exchangeitemlist = []
        m = m - this.exchangetotalmoney
      } else if (this.exchangeitemlisttemp) {
        this.exchangeitemlist = JSON.parse(this.exchangeitemlisttemp)
      }
      m = m - (this.morediscountsmoney + this.fullminusmoney)
      this.pay_money = (m + parseFloat(this.freight)).toFixed(2)
      return m.toFixed(2)
    }
  },
  watch: {
    itemidsAddress: function (val) {
      var that = this
      that.freight = 0
      var itemids = val.split('|')[0],
        addressid = val.split('|')[1],
        buynums = val.split('|')[2]
      if (that.$route.query.acttype == 'hc_welfare') {
        that.freight = 0
      } else {
        if (itemids.length > 0 && addressid > 0) {
          var urlFreight
          if (
            that.$route.query.yl == 1 &&
            that.$route.query.newperson != 1 &&
            that.$route.query.ylcc != 9 &&
            that.$route.query.lb != 1 &&
            that.$route.query.ann != 1 &&
            that.$route.query.anncc != 1 &&
            that.$route.query.mtact != 1 &&
            that.$route.query.prize != 1 &&
            that.$route.query.defectivegood != 1
          ) {
            urlFreight =
              that.$ajax.calculateActFreight_URL +
              '?activitytype=' +
              (that.$route.query.yl == 1 ? 7 : that.$route.query.ms == 1 ? 8 : '') +
              '&addressid=' +
              addressid
          } else if (
            that.$route.query.yl == 1 &&
            that.$route.query.ylcc == 9 &&
            that.$route.query.mtact != 1
          ) {
            urlFreight =
              that.$ajax.calculateActFreight_URL + '?activitytype=11' + '&addressid=' + addressid
          } else {
            urlFreight =
              that.$ajax.calculateFreight_URL +
              '?itemid=' +
              itemids +
              '&addressid=' +
              addressid +
              '&buynum=' +
              buynums
          }
          that.$customRequestAjax(urlFreight).then(function (res) {
            if (res.data.code === 200) {
              if (res.data.freight && parseFloat(res.data.freight) > 0) {
                that.freight = res.data.freight
              }
            }
          })
        }
      }
    },
    totalmoney: function (val) {
      var that = this,
        mtacttotalmoney = 0
      that.inittotalmoney = 0
      that.mtacttotalmoney = 0
      that.inittotalmoneyshow = '0.00'
      var depositmoney = 0
      that.list.map(function (item) {
        if (item.isdeposit == 1 && item.depositmoney) {
          depositmoney += parseFloat(item.depositmoney)
        }
        mtacttotalmoney += parseFloat(item.price) * parseInt(item.num || 1)
      })
      mtacttotalmoney =
        that.directReductionmoney > 0
          ? mtacttotalmoney + that.directReductionmoney
          : mtacttotalmoney
      that.mtacttotalmoney = parseFloat(mtacttotalmoney).toFixed(2)
      that.inittotalmoney =
        that.discountrule.discountenable == 1
          ? parseFloat(that.totalmoney) +
            parseFloat(that.discountmoney) +
            parseFloat(that.giftmoney)
          : parseFloat(that.totalmoney) + parseFloat(that.giftmoney)
      that.inittotalmoney += depositmoney
      that.inittotalmoney =
        that.directReductionmoney > 0
          ? that.inittotalmoney + that.directReductionmoney
          : that.inittotalmoney
      that.inittotalmoney = parseFloat(that.inittotalmoney).toFixed(2)
      that.inittotalmoneyshow = (
        (that.mtacttotalmoney ? that.mtacttotalmoney : that.inittotalmoney) - that.recommendmoney
      ).toFixed(2)
    }
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({ path: 'addorder' })
    }
    this.getData('init')
    if (sessionStorage.getItem('choose_integral')) {
      let integral = JSON.parse(sessionStorage.getItem('choose_integral'))
      this.integralmoney = parseFloat(integral.integermoney)
      this.radio = integral.radio
      this.integralChecked = integral.checked
    }
    var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
    if (sessionStorage.getItem('choose_coupon')) {
      let coupon = JSON.parse(sessionStorage.getItem('choose_coupon'))
      this.localCoupon = coupon
      this.couponmoney = parseFloat(this.localCoupon.price)
      this.couponChecked = this.localCoupon.checked
      this.couponstitle = this.localCoupon.couponname + ' ￥' + parseFloat(this.localCoupon.price)
    } else if (typeof shopConfirmResult.couponChecked === 'boolean') {
      this.couponChecked = shopConfirmResult.couponChecked
    }
    localStorage.removeItem('showsubscribegoods')
    localStorage.removeItem('fivehundred')
    localStorage.removeItem('eighthundred')
    // 挂载完成后，判断浏览器是否支持popstate
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.goBack, false)
    }
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
    window.removeEventListener('popstate', this.goBack, false)
  },
  beforeRouteEnter: function (to, from, next) {
    if (
      from.path == '/pay' ||
      from.path == '/payResult' ||
      from.path == '/orderdetails' ||
      from.path == '/classification'
    ) {
      next(function (vm) {
        vm.$router.go(-1)
      })
    } else {
      next()
    }
  },
  methods: {
    // 获取图形验证码
    getCodeImg() {
      let width = this.$refs.codeImg.clientWidth
      let height = this.$refs.codeImg.clientHeight
      this.code = ''
      this.timeout = new Date().getTime() + '' + random_string(16)
      this.codeImg =
        basepath +
        'Msg/Captcha/getValidateCode?sessionid=' +
        this.timeout +
        '&width=' +
        width +
        '&height=' +
        height
    },
    Code() {
      let that,
        type,
        area_code = 86,
        url
      that = this
      type = 3
      url =
        that.$ajax.getValidCode_URL +
        '?newVersion=1&mobile=' +
        that.mobile +
        '&code=' +
        that.code +
        '&sessionid=' +
        that.timeout +
        '&type=' +
        type +
        '&area_code=' +
        area_code
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          that.time = 60
          that.countdown()
        } else if (res.data.code == '10011') {
          layer.msg(res.data.msg)
          that.getCodeImg()
        }
      })
    },
    countdown: function () {
      var that = this
      var timer = setInterval(function () {
        that.time--
        if (that.time <= 0) {
          that.time = 0
          // if (!that.imgCodeWrapFlag) {
          //   that.imgCodeWrapFlag = true
          // }
          clearInterval(timer)
        }
      }, 1000)
    },
    sendAgain: function () {
      if (this.check('sms')) this.Code()
    },
    check: function (type) {
      if (!this.mobile) {
        this.$toast('请先输入手机号')
        return false
      } else if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
        this.$toast('请输入正确的手机号')
        return false
      } else if (!this.code) {
        this.$toast('请输入图片验证码')
        return false
      } else if (!this.sms) {
        if (type == 'sms') {
          return true
        } else {
          this.$toast('请先输入短信验证码')
          return false
        }
      } else {
        return true
      }
    },
    confirm: function () {
      if (this.check()) {
        var url = this.$ajax.smsCodeVerify_URL + '?mobile=' + this.mobile + '&code=' + this.sms
        this.$customRequestAjax(url).then((res) => {
          if (res.data.code == 200) {
            // this.upVip()
            this.goNext()
          } else {
            this.$toast('验证码有误')
            this.sms = ''
          }
        })
      }
    },
    cancel: function () {
      this.mobile = ''
      this.code = ''
      this.sms = ''
      this.goNext()
    },
    launch: function (e) {
      setTimeout(function () {
        window.location = downloadshoppath
      }, 500)
    },
    error: function () {
      // this.$toast('请先下载创客云商app')
      window.location = downloadshoppath
    },
    // shopConfirmResult.totalmoney 缓存总金额=现销售价(item.price*item.num)的合计金额
    getData: function (type) {
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult')),
        urlOrder
      urlOrder =
        this.$ajax.getConfirmItems_URL +
        '?skuids=' +
        shopConfirmResult.skuidArr.join() +
        '&live_ids=' +
        (shopConfirmResult.liveId ? shopConfirmResult.liveId.join() : '') +
        '&room_id=' +
        (shopConfirmResult.roomId ? shopConfirmResult.roomId.join() : '') +
        '&from=' +
        shopConfirmResult.from +
        '&item_num=' +
        shopConfirmResult.itemNum.join() +
        '&newBuygift=1'
      if (this.$route.query.np == 1) {
        urlOrder += '&type=1'
      } else if (this.$route.query.ms == 1) {
        urlOrder += '&limitid=' + shopConfirmResult.limitid
      } else {
        urlOrder +=
          '&communityid=' +
          (shopConfirmResult.communityid != undefined ? shopConfirmResult.communityid : '')
      }
      if (shopConfirmResult.recommendskuid) {
        urlOrder +=
          '&recommendskuid=' +
          shopConfirmResult.recommendskuid +
          '&recommendnum=' +
          shopConfirmResult.recommendnum
      }
      var urlAddress1 = this.$ajax.getAddressById_URL + '?id=' + this.$route.query.addressid
      var urlAddress2 = this.$ajax.getDefaultAddress_URL
      var giftlist = []
      this.depositmoney = 0
      var that = this
      that.$customRequestAjax(urlOrder).then(function (res) {
        if (res.data.code === 200) {
          if (res.data.couponmsg) {
            that.$toast({
              message: res.data.couponmsg,
              icon: require('../../assets/images/succ.png'),
              duration: 0,
              className: 'get_coupon_toast'
            })
          }
          that.is_50vipentrance = res.data.is_50vipentrance
          that.is_50vipentranceName = res.data.is_50vipentranceName
          that.ispreferentialmutex = res.data.ispreferentialmutex || 0
          that.useintegralitemjson = res.data.useintegralitemjson || ''
          that.changebuystatus = res.data.changebuystatus || 0
          that.exchangestatus = res.data.exchangestatus || 0
          that.birthdaygift_paymoney = parseFloat(res.data.birthdaygift_paymoney) || 0
          that.subscribegoodsrule = res.data.subscribegoodsrule ? res.data.subscribegoodsrule : {}
          that.morediscounts = res.data.morediscounts || {}
          if (that.morediscounts.morediscountsmoney) {
            that.morediscountsmoney = parseFloat(that.morediscounts.morediscountsmoney)
          }
          if (that.exchangestatus == 1) {
            that.exchange_paymoney = res.data.exchange_paymoney
            that.exchangeitemlist =
              shopConfirmResult.exchangeitemlist && shopConfirmResult.exchangeitemlist != '[]'
                ? JSON.parse(shopConfirmResult.exchangeitemlist)
                : res.data.exchangeitemlist || []
          }
          if (that.exchangeitemlist.length > 0) {
            that.exchangemaxcanbuycnt = that.exchangeitemlist[0].maxcanbuycnt
          }
          for (let i = 0; i < that.exchangeitemlist.length; i++) {
            let changebuytip = that.exchangeitemlist[i].changebuytip,
              changebuylist = that.exchangeitemlist[i].changebuylist

            changebuytip = changebuytip.replace(/[\r\n]/g, '&')
            that.exchangeitemlist[i].tipLable = changebuytip.substring(0, changebuytip.indexOf('&'))
            that.exchangeitemlist[i].tipTime = changebuytip.substring(changebuytip.indexOf('&') + 1)

            for (let j = 0; j < changebuylist.length; j++) {
              if (that.exchangeitemlist[i].maxcanbuycnt == 100000) {
                changebuylist[j].num = 1
              } else {
                changebuylist[j].num = changebuylist[j].canbuycnt
              }
            }
          }
          if (that.exchangeitemlist.length) {
            that.exchangeitemlisttemp = JSON.stringify(that.exchangeitemlist)
          }
          that.recommenditemlist =
            shopConfirmResult.recommendclose == 1 ? [] : res.data.recommenditemlist || []
          if (that.recommenditemlist.length) {
            that.recommenditemlist[0].num = parseInt(that.recommenditemlist[0].num)
            that.recommenditemlist[0].canbuycnt = parseInt(that.recommenditemlist[0].canbuycnt)
            shopConfirmResult.recommendskuid = that.recommenditemlist[0].skuid
            shopConfirmResult.recommendnum = that.recommenditemlist[0].num
            that.recommendnumber = parseInt(that.recommenditemlist[0].num)
            that.recommendmoney =
              parseFloat(that.recommenditemlist[0].price) * parseInt(that.recommenditemlist[0].num)
          }
          that.fullgift = res.data.fullgiftrulenew || {}
          that.fullDiscountRule = res.data.fullDiscountRule
          if (shopConfirmResult.gift_list) {
            that.fullgiftrulenew = JSON.parse(shopConfirmResult.gift_list)
            var list = that.fullgift.list,
              index = null
            for (var i = 0; i < list.length; i++) {
              if (list[i].giftid == that.fullgiftrulenew[0].giftid) {
                index = i
                break
              }
            }
            list.splice(index, 1, that.fullgiftrulenew[0])
            that.fullgift.list = list
          } else {
            that.fullgiftrulenew =
              String(that.fullgift) != '{}' && that.fullgift.list && that.fullgift.list.length
                ? that.fullgift.list
                : []
          }
          that.fullMinusRules = res.data.fullMinusRules || {}
          that.buygiftrule = res.data.buygiftrule || {}

          let itemlist = res.data.itemlist
          if (
            that.$route.query.yl == 1 ||
            that.$route.query.ms == 1 ||
            that.$route.query.ylact == 1
          ) {
            var arr = [],
              temp1 = 0
            itemlist.map(function (item) {
              if (item.ishalfprice && !temp1) {
                temp1 = 1
                that.ishalfprice = item.ishalfprice
              }
              /**
               * 预售付定金活动商品
               * 后端接口定义
               *  key: price, // 销售价格
               *  key: finalpaymentmoney, // 尾款价格
               * 前端定义
               *  new key: finalprice = price, // 销售价格
               *  key: price = finalpaymentmoney, // 尾款价格
               * */
              if (item.isdeposit == 1) {
                item.finalprice = item.price
                item.price = item.finalpaymentmoney
                that.depositmoney += parseFloat(item.depositmoney)
              }

              item.isdiscount = 0
              item.isfullgift = 0
              if (item.isgift == 0) {
                arr.push(item)
              }
              /**
               * activity: 69元任选3件
               * cteatetime: 20230222
               * creater: gao en hui
               * scene：69元任选三件商品单价显示原价，可直接赋值销售价字段，该活动最终实付金额固定为￥69.00
               * */
              if (that.$route.query.mtact == 1) {
                item.price = item.cost_price
              }
            })
            that.list = arr
          } else {
            var temp1 = 0
            that.subscribegoods_totalmoney = 0
            itemlist.map(function (item) {
              if (item.ishalfprice && !temp1) {
                temp1 = 1
                that.ishalfprice = item.ishalfprice
              }
              /**
               * 预售付定金活动商品
               * 后端接口定义
               *  key: price, // 销售价格
               *  key: finalpaymentmoney, // 尾款价格
               * 前端定义
               *  new key: finalprice = price, // 销售价格
               *  key: price = finalpaymentmoney, // 尾款价格
               * */
              if (item.isdeposit == 1) {
                item.finalprice = item.price
                item.price = item.finalpaymentmoney
                that.depositmoney += parseFloat(item.depositmoney)
              }
              /**
               * activity: 38预约活动商品
               * cteatetime: 20230216
               * creater: gao en hui
               * scene：只考虑正品下单参与活动的商品（换购、加购等活动不考虑是否参与情况）
               * */
              if (Object.keys(that.subscribegoodsrule).length) {
                if (
                  (',' + that.subscribegoodsrule.notitems + ',').indexOf(',' + item.skuid + ',') <=
                  -1
                ) {
                  that.subscribegoods_totalmoney += parseFloat(
                    parseFloat(item.price) * parseInt(item.num)
                  )
                }
              }
            })
            that.list = itemlist
          }
          that.fraud = res.data.risktips
          that.fullgiftrule = res.data.fullgiftrule
          that.discountrule = res.data.discountrule
          that.couponstips = res.data.couponstips
          that.drawprizetips = res.data.drawprizetips
          that.halfprice = {
            halfpricestatus: res.data.halfpricestatus,
            halfpricedesc: res.data.halfpricedesc,
            halfactname: res.data.halfactname,
            halfactlabel: res.data.halfactlabel
          }
          // that.totalnum = shopConfirmResult.totalnum
          if (
            that.$route.query.iszg == 1 ||
            that.$route.query.yl == 1 ||
            that.$route.query.ylact == 1 ||
            that.$route.query.ms == 1
          ) {
            res.data.integer = {
              allinteger: 0,
              integerlist: [],
              integeruserate: 0,
              integral_rule: [],
              integermoneyrule: [],
              ispreferentialmutex: 0
            }
            res.data.couponlist = []
            res.data.goodscouponrule = []
          }
          that.integerrule = res.data.integer
          that.nocoupontext = res.data.couponlist.length > 0 ? '现金券不可用' : '无可用现金券'
          that.couponlistrule = res.data.couponlist
          that.goodscouponrule = res.data.goodscouponrule
          localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
          that.count('init')
        } else if (res.data.code == 10000) {
          // 游客身份 跳转登录
          if (!isWeixin()) {
            if (that.waptoken.waptoken && that.waptoken.waptoken == that.waptoken.tourists) {
              that.$router.push('/myorder')
              that.$store.commit('ORDERLIST_NAVID', 0)
              that.$router.push({
                path: '/login',
                query: {
                  routeval: 'myorder'
                }
              })
            }
          }
        }
      })
      if (type == 'init') {
        var func = (callback) => {
          if (this.$route.query.addressid) {
            this.$customRequestAjax(urlAddress1).then(function (res) {
              if (res.data.code === 200) {
                that.addressVal = res.data.addressdata
                if (typeof callback === 'function') callback()
              }
            })
          } else {
            this.$customRequestAjax(urlAddress2).then(function (res) {
              if (res.data.code === 200) {
                that.addressVal = res.data.addressdata
                if (typeof callback === 'function') callback()
              }
            })
          }
        }
        func(() => {
          that.discern(that.addressVal.address, (res) => {
            if (res != null) {
              let area = []
              if (this.addressVal.area.indexOf('\n') >= 0) {
                area = this.addressVal.area.split('\n')
              } else {
                area = this.addressVal.area.split(' ')
              }
              if (
                (area.length == 3 && (area[0] != res.data.province || area[1] != res.data.city)) ||
                (area.length == 1 && area[0].indexOf(res.data.province + res.data.city) < 0)
              ) {
                this.areatemp = res.data.province + ' ' + res.data.city + ' ' + res.data.county
                this.areaidtemp =
                  res.data.province_code + ',' + res.data.city_code + ',' + res.data.county_code
                this.addresstemp = res.data.detail
              } else {
                this.areatemp = ''
                this.areaidtemp = ''
                this.addresstemp = ''
              }
            }
          })
        })
      }
    },
    discern(site, callback) {
      discernFunc(
        site,
        () => {
          let url = this.$ajax.initAddress_URL + '?text=' + site
          this.$customRequestAjax(url).then((res) => {
            if (res != null && res.data.code == 200) {
              if (typeof callback === 'function') callback(res)
            } else {
              if (typeof callback === 'function') callback(null)
            }
          })
        },
        () => {
          if (typeof callback === 'function') callback(null)
        }
      )
    },
    goflod: function (type) {
      var temp = this.$route.fullPath.split('?')
      var url =
        '/static/wx/html/20190820/Flod/flodlist.html?type=addorder&acttype=' +
        type +
        '&goodsnum=' +
        this.goodsnum
      if (temp.length >= 2) {
        url += '&pathdata=' + encryption(this.$route.fullPath.split('?')[1])
      }
      window.location = url
    },
    gofullgift: function () {
      var temp = this.$route.fullPath.split('?')
      var url =
        '/static/wx/html/fullGift/index.html?type=addorder&currentdiscount=' + this.currentdiscount
      var skuids = [],
        nums = []
      this.list.map((item) => {
        if (item.isgift != 1 && item.isbuygift != 1 && item.isgiftproduct != 1) {
          skuids.push(item.skuid)
          nums.push(item.num)
        }
      })
      url += '&skuids=' + skuids.join() + '&nums=' + nums.join()
      if (temp.length >= 2) {
        url += '&pathdata=' + encryption(this.$route.fullPath.split('?')[1])
      }
      window.location = url
    },
    discountFn: function () {
      var that = this
      let discountlist = [],
        discount_rule = {}
      that.goodsnum = 0
      that.currentdiscountdata = 0
      that.list.map(function (item) {
        // that.itemids = that.itemids == '' ? item.itemid : that.itemids + ',' + item.itemid
        if (item.isdiscount == 1 || item.isFullDiscount == 1) {
          that.goodsnum += parseInt(item.num && parseInt(item.num) >= 0 ? item.num : 1)
        }
      })
      // 折上折
      if (that.discountrule && that.discountrule.discountenable == 1) {
        discount_rule = that.discountrule
        discountFunc()
      } else if (that.fullDiscountRule && that.fullDiscountRule.discountenable == 1) {
        // 限时折扣
        discount_rule = {
          discountenable: that.fullDiscountRule.discountenable,
          discountlist: that.fullDiscountRule.rulelist
        }
        discount_rule.discountlist.map((item) => {
          item.itemnum = item.num
        })
        discountFunc()
      }
      function discountFunc() {
        discountlist = discount_rule.discountlist
        if (parseInt(that.goodsnum) == 0) {
          var discount = discountlist[0].discount
          var txt = (discount * 100) % 10 == 0 ? (discount * 100) / 10 : discount * 100
          that.FlodMsg = '惊喜！选购活动商品最高可享受' + txt + '折'
          that.currentdiscountdata = 1
        } else if (parseInt(that.goodsnum) >= parseInt(discountlist[0].itemnum)) {
          let discount = discountlist[0].discount
          let txt = (discount * 100) % 10 == 0 ? (discount * 100) / 10 : discount * 100
          if (that.fullgiftrule.actstatus && parseInt(that.fullgiftrule.actstatus) == 1) {
            that.FlodMsg = ''
          } else {
            that.FlodMsg = '惊喜！已选' + that.goodsnum + '件享' + txt + '折'
          }
          that.currentdiscountdata = discount
        } else if (
          parseInt(that.goodsnum) < parseInt(discountlist[discountlist.length - 1].itemnum)
        ) {
          let discount1 = discountlist[discountlist.length - 1].discount
          let txt = (discount1 * 100) % 10 == 0 ? (discount1 * 100) / 10 : discount1 * 100
          that.FlodMsg =
            '惊喜！已选' +
            that.goodsnum +
            '件，再加' +
            (parseInt(discountlist[discountlist.length - 1].itemnum) - that.goodsnum) +
            '件即可享受' +
            txt +
            '折。'
          that.currentdiscountdata = 1
        } else {
          try {
            discountlist.forEach(function (item, index) {
              if (parseInt(that.goodsnum) >= parseInt(item.itemnum)) {
                let discount1 = item.discount
                let discount2 = discountlist[index - 1].discount
                let txt = (discount1 * 100) % 10 == 0 ? (discount1 * 100) / 10 : discount1 * 100
                let txt1 = (discount2 * 100) % 10 == 0 ? (discount2 * 100) / 10 : discount2 * 100
                that.FlodMsg =
                  '惊喜！已选' +
                  that.goodsnum +
                  '件享' +
                  txt +
                  '折，再加' +
                  (parseInt(discountlist[index - 1].itemnum) - that.goodsnum) +
                  '件即可享受' +
                  txt1 +
                  '折。'
                that.currentdiscountdata = discount1
                throw new Error()
              }
            })
          } catch (e) {}
        }
      }
      this.fullgiftFn()
      this.fullminusdiscountFn()
    },
    fullgiftFn: function () {
      var that = this
      // 满赠
      if (this.fullgiftrule && parseInt(this.fullgiftrule.actstatus) == 1 && !this.FlodMsg) {
        if (this.fullgiftrule.rulelist && this.fullgiftrule.rulelist.length > 0) {
          var rulelist = this.fullgiftrule.rulelist
          var price = 0
          that.list.forEach(function (item) {
            if (item.isfullgift == 1) {
              if (parseInt(item.isdiscount) == 1 && that.currentdiscountdata > 0) {
                price += Number(item.price) * parseInt(item.num) * Number(that.currentdiscountdata)
              } else {
                price += Number(item.price) * parseInt(item.num)
              }
            }
          })
          that.currentfullgiftmoney = parseFloat(
            price -
              (that.couponmoney +
                that.integralmoney +
                that.morediscountsmoney +
                that.fullminusmoney)
          ).toFixed(2)
          if (!isNaN(Number(that.currentfullgiftmoney))) {
            if (
              parseFloat(that.currentfullgiftmoney) == 0 ||
              parseFloat(that.currentfullgiftmoney) <
                parseFloat(rulelist[rulelist.length - 1].allmoney)
            ) {
              let m = !isNaN(Number(rulelist[rulelist.length - 1].allmoney))
                ? parseFloat(
                    Number(rulelist[rulelist.length - 1].allmoney) -
                      Number(that.currentfullgiftmoney)
                  ).toFixed(2)
                : '0.00'
              let m1 = !isNaN(parseFloat(rulelist[rulelist.length - 1].senditemprice))
                ? parseFloat(rulelist[rulelist.length - 1].senditemprice).toFixed(2)
                : '0.00'
              that.FullGiftMsg =
                '惊喜！还差<span>' +
                m +
                '</span>元，即送价值<span>' +
                (parseFloat(m1) > 0
                  ? m1
                  : parseFloat(rulelist[rulelist.length - 1].itemprice).toFixed(2)) +
                '</span>元' +
                rulelist[rulelist.length - 1].senditemname
            } else if (parseFloat(that.currentfullgiftmoney) >= parseFloat(rulelist[0].allmoney)) {
              let m = !isNaN(parseFloat(rulelist[0].allmoney))
                ? parseFloat(rulelist[0].allmoney).toFixed(2)
                : '0.00'
              let m1 = !isNaN(parseFloat(rulelist[0].senditemprice))
                ? parseFloat(rulelist[0].senditemprice).toFixed(2)
                : '0.00'
              that.FullGiftMsg =
                '惊喜！已满<span>' +
                m +
                '</span>元，送价值<span>' +
                (parseFloat(m1) > 0 ? m1 : parseFloat(rulelist[0].itemprice).toFixed(2)) +
                '</span>元' +
                rulelist[0].senditemname
            } else {
              try {
                rulelist.forEach(function (item, index) {
                  if (parseFloat(that.currentfullgiftmoney) >= parseFloat(item.allmoney)) {
                    let m = !isNaN(parseFloat(rulelist[index].allmoney))
                      ? parseFloat(Number(rulelist[index].allmoney)).toFixed(2)
                      : '0.00'
                    let m1 = !isNaN(parseFloat(rulelist[index].senditemprice))
                      ? parseFloat(rulelist[index].senditemprice).toFixed(2)
                      : '0.00'
                    that.FullGiftMsg =
                      '惊喜！已满<span>' +
                      m +
                      '</span>元，送价值<span>' +
                      (parseFloat(m1) > 0 ? m1 : parseFloat(rulelist[index].itemprice).toFixed(2)) +
                      '</span>元' +
                      rulelist[index].senditemname
                    let m2 = !isNaN(parseFloat(rulelist[index - 1].allmoney))
                      ? parseFloat(
                          Number(rulelist[index - 1].allmoney) - Number(that.currentfullgiftmoney)
                        ).toFixed(2)
                      : '0.00'
                    let m3 = !isNaN(parseFloat(rulelist[index - 1].senditemprice))
                      ? parseFloat(rulelist[index - 1].senditemprice).toFixed(2)
                      : '0.00'
                    that.FullGiftMsg +=
                      '，再加<span>' +
                      m2 +
                      '</span>元，奖品升级为价值<span>' +
                      (parseFloat(m3) > 0
                        ? m3
                        : parseFloat(rulelist[index - 1].itemprice).toFixed(2)) +
                      '</span>元' +
                      rulelist[index - 1].senditemname
                    throw new Error()
                  }
                })
              } catch (e) {}
            }
          }
        }
        if (that.FullGiftMsg != '') {
          that.FullGiftMsg += '（' + this.fullgiftrule.actname + '）'
        }
      }
    },

    fullminusdiscountFn: function () {
      var that = this
      that.fullminustotalmoney = 0
      that.list.map(function (item) {
        if (item.isfullMinus == 1) {
          that.fullminustotalmoney +=
            parseFloat(item.price) * parseInt(item.num && parseInt(item.num) >= 0 ? item.num : 1)
        }
      })
      // 满减
      if (that.fullMinusRules.actStatus == 1) {
        if (that.fullMinusRules.isSuperpose == 1 && that.fullminustotalmoney > 0) {
          let variable = Math.floor(
            that.fullminustotalmoney / parseFloat(that.fullMinusRules.fullMoney)
          )
          variable = variable + 1
          that.fullminusmoney = parseFloat(that.fullMinusRules.minusMoney) * (variable - 1)
          that.extraMinusMoney = parseFloat(that.fullMinusRules.extraMinusMoney) * (variable - 1)
          that.fullminusmoney = that.fullminusmoney + that.extraMinusMoney
        } else if (that.fullminustotalmoney > 0) {
          if (that.fullminustotalmoney >= that.fullMinusRules.fullMoney) {
            that.fullminusmoney = parseFloat(that.fullMinusRules.minusMoney)
            that.extraMinusMoney = parseFloat(that.fullMinusRules.extraMinusMoney)
            that.fullminusmoney = that.fullminusmoney + that.extraMinusMoney
          }
        }
        that.list.map(function (item) {
          if (item.isfullMinus == 1) {
            let price =
              parseFloat(item.price) * parseInt(item.num && parseInt(item.num) >= 0 ? item.num : 1)
            item.fullminusmoney = parseFloat(
              price * (that.fullminusmoney / that.fullminustotalmoney)
            ).toFixed(2)
            that.itemids.forEach(function (item1) {
              if (item1.id == item.skuid) {
                item1.fullminusmoney = item.fullminusmoney ? parseFloat(item.fullminusmoney) : 0
              }
            })
          }
        })
      }
    },
    /**
     * 初始化金额计算
     **/
    initmoney: function (type) {
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult')),
        that = this,
        totalmoney = 0
      that.totalnum = 0
      that.totalnumshow = 0
      that.birthdaygifttotalnum = 0
      that.directReductionmoney = 0
      that.itemids = []
      if (!sessionStorage.getItem('choose_coupon') && !shopConfirmResult.init_coupon_data) {
        shopConfirmResult.init_coupon_data = 0 // 初始化自动匹配现金券数据 0用户未选择，需匹配； 1用户主动已选择
        localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      }
      if (shopConfirmResult.changebuy_list) {
        var changebuylist = JSON.parse(shopConfirmResult.changebuy_list)
        changebuylist.map((item) => {
          if (item.directReductionPrice && item.directReductionPrice > 0) {
            that.directReductionmoney += item.directReductionPrice * item.num
            item.new_price = parseFloat(
              parseFloat(item.price) + parseFloat(item.directReductionPrice)
            ).toFixed(2)
          }
          item.price = item.changebuy_price
          item.ischangebuy = 1
          totalmoney += parseFloat(item.price) * parseInt(item.num)
        })
        if (type == 'init') that.list = that.list.concat(changebuylist)
      }
      that.list.map(function (item) {
        // that.itemids = that.itemids == '' ? item.itemid : that.itemids + ',' + item.itemid
        if (
          item.isgift != 1 &&
          item.isgiftproduct != 1 &&
          (item.ismorediscounts != 1 || (item.ismorediscounts == 1 && item.couponsenable == 1))
        ) {
          let moredismoney = 0
          if (item.ismorediscounts == 1 && item.num >= item.morediscountsitemnum) {
            if (item.issuperposition != 0) {
              moredismoney =
                parseFloat(item.morediscountsmoney) * parseInt(item / item.morediscountsitemnum)
            } else {
              moredismoney = parseFloat(item.morediscountsmoney)
            }
          }
          that.itemids.push({
            id: item.skuid,
            num: item.num && parseInt(item.num) >= 0 ? item.num : 1,
            price: item.price,
            isdiscount: item.isdiscount,
            moredismoney: moredismoney || 0,
            fullminusmoney: 0
          })
        }
        if (item.directReductionPrice && item.directReductionPrice > 0) {
          that.directReductionmoney += item.directReductionPrice * item.num
          item.new_price = parseFloat(
            parseFloat(item.price) + parseFloat(item.directReductionPrice)
          ).toFixed(2)
        }
        // if (item.isgift != 1 && item.isgiftproduct != 1) {
        that.totalnum = that.totalnum + parseInt(item.num && parseInt(item.num) >= 0 ? item.num : 1)
        that.totalnumtemp = that.totalnum
        if (item.isintellrecommend != 1) {
          that.totalnumshow =
            that.totalnumshow + parseInt(item.num && parseInt(item.num) >= 0 ? item.num : 1)
        }
        if (item.isbirthdaygift == 1) {
          that.birthdaygifttotalnum += parseInt(item.num && parseInt(item.num) >= 0 ? item.num : 1)
        }
        // }
      })
      that.totalmoney =
        parseFloat(shopConfirmResult.totalmoney) +
        totalmoney -
        that.discountmoney -
        parseFloat(that.fullDiscountRule.fullDiscountmoney) +
        that.exchangetotalmoney
      that.totalprice = that.totalmoney
      if (type == 'init') that.listtemp = JSON.stringify(that.list)
    },
    getRule: function (integer, couponlist) {
      this.useIntegerlist = []
      this.nouseIntegerlist = []
      this.couponlist = []
      var that = this
      if (integer) {
        that.integerAllList = integer.integerlist
        that.totalIntegral = integer.allinteger
        that.interate = integer.integeruserate
        that.integralrule = integer.integral_rule
      }
      // that.integralChecked = true

      // if (that.interate == 0) {
      //   that.isconditions = 1
      // }
      if (
        that.fullMinusRules.actStatus == -1 ||
        that.fullminusmoney <= 0 ||
        !(that.fullMinusRules.actStatus && that.fullMinusRules.fullMinusCouponEnable != 1)
      ) {
        that.couponlist = couponlist
      } else {
        sessionStorage.removeItem('choose_coupon')
      }
      that.getjifen()
      that.loadcoupons()
      that.saveIntegral(that.integralChecked, 0)
      that.checkProduct()
    },
    checkProduct: function () {
      var that = this,
        choose_product_couponid = '',
        isremove = 0,
        money = 0
      this.productlist = []
      if (sessionStorage.getItem('choose_product')) {
        choose_product_couponid = JSON.parse(sessionStorage.getItem('choose_product')).id
      }
      this.goodscouponrule.map((item) => {
        item.isChoose = false
        money = 0
        this.itemids.map((idsitem) => {
          if (item.items == '') {
            if ((',' + item.notitems + ',').indexOf(',' + idsitem.id + ',') > -1) {
              money =
                money +
                (idsitem.price * idsitem.num - idsitem.moredismoney - idsitem.fullminusmoney)
            }
          } else if (item.items != '') {
            if ((',' + item.notitems + ',').indexOf(',' + idsitem.id + ',') > -1) {
              money =
                money +
                (idsitem.price * idsitem.num - idsitem.moredismoney - idsitem.fullminusmoney)
            } else if ((',' + item.items + ',').indexOf(',' + idsitem.id + ',') <= -1) {
              money =
                money +
                (idsitem.price * idsitem.num - idsitem.moredismoney - idsitem.fullminusmoney)
            }
          }
        })
        if (parseFloat(that.paymoney) - money >= parseFloat(item.useprice)) {
          that.productlist.push(item)
        } else {
          if (choose_product_couponid == item.id && !isremove) {
            isremove = 1
          }
        }
      })
      sessionStorage.removeItem('choose_product')
      that.getProduct()
    },
    showActDesc: function (type) {
      var that = this
      var isdiscount = 0
      var isfullgift = 0
      that.list.map(function (item) {
        if (item.isdiscount == 1) {
          isdiscount = 1
        }
        if (item.isfullgift == 1) {
          isfullgift = 1
        }
      })
      var obj = {
        isdiscount: isdiscount,
        isfullgift: isfullgift
      }
      that.msglist = []
      if (type != 'morediscounts') {
        if (
          that.discountrule &&
          that.discountrule.discountenable == 1 &&
          that.discountrule.discountlist &&
          obj.isdiscount == 1
        ) {
          var msg = []
          that.discountrule.discountlist.forEach(function (item, index) {
            var txt =
              (item.discount * 100) % 10 == 0 ? (item.discount * 100) / 10 : item.discount * 100
            msg.push(item.itemnum + '件' + txt + '折')
          })
          var discountruledesc = '满' + msg.join(',')
          that.msglist.push({
            enable: that.discountrule.discountenable,
            shortdesc: discountruledesc,
            desc: that.discountrule.discountdesc,
            name: that.discountrule.name,
            actlabel: that.discountrule.actlabel
          })
        }
        if (
          that.fullgiftrule &&
          that.fullgiftrule.actstatus == 1 &&
          that.fullgiftrule.rulelist &&
          obj.isfullgift == 1
        ) {
          that.msglist.push({
            enable: that.fullgiftrule.actstatus,
            shortdesc: that.fullgiftrule.actdesc,
            desc: that.fullgiftrule.actdesc,
            name: that.fullgiftrule.actname,
            actlabel: that.fullgiftrule.actlabel
          })
        }
        try {
          if (that.fullgift && String(that.fullgift) != '{}' && that.fullgift.list.length > 0) {
            that.fullgift.actstatus = 1
            that.msglist.push({
              enable: that.fullgift.actstatus,
              shortdesc: that.fullgift.actdesc,
              desc: that.fullgift.actdesc,
              name: that.fullgift.actname,
              actlabel: ''
            })
          }
        } catch (e) {}
        if (that.halfprice.halfpricestatus == 1) {
          that.msglist.push({
            enable: that.halfprice.halfpricestatus,
            shortdesc: that.halfprice.halfpricedesc,
            desc: that.halfprice.halfpricedesc,
            name: that.halfprice.halfactname,
            actlabel: that.halfprice.halfactlabel
          })
        }
      } else {
        if (!that.morediscounts.discountenable == 1) {
          that.msglist.push({
            enable: parseFloat(that.morediscountsmoney) > 0 ? 1 : 0,
            shortdesc: that.morediscounts.discountdesc ? that.morediscounts.discountdesc : '',
            desclist: that.morediscounts.discountlist ? that.morediscounts.discountlist : [],
            desc: '',
            name: '',
            actlabel: '多件立减'
          })
        }
      }
      that.showaction = true
    },
    /**
     * 2期加购活动
     * */
    // 商品数量加减
    addToCart(type, index, indexB, item) {
      if (this.exchangetotalNumber + 1 > this.exchangemaxcanbuycnt && type == 1) {
        this.$toast('超出最大可加购数量')
        return
      }
      let num = parseInt(item.num),
        max = parseInt(item.canbuycnt)
      if (type) {
        if (num >= max) {
          this.$toast('最多可购买' + max + '件')
          return
        }
        num += 1
      } else {
        if (num <= 1) {
          this.$toast('不能再减了')
          return
        }
        num += -1
      }
      this.exchangeitemlist[index].changebuylist[indexB].num = num
      this.exchangeitemlisttemp = JSON.stringify(this.exchangeitemlist)
      this.count()
    },

    recommendAddToCart(type, index, item, isclose) {
      let num = parseInt(item.num),
        max = parseInt(item.canbuycnt),
        shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      if (type) {
        if (num >= max) {
          this.$toast('最多可购买' + max + '件')
          return
        }
        num += 1
        shopConfirmResult.totalmoney =
          parseFloat(shopConfirmResult.totalmoney) + parseFloat(this.recommenditemlist[index].price)
        shopConfirmResult.totalnum = shopConfirmResult.totalnum + 1
      } else {
        num += -1
        shopConfirmResult.totalmoney =
          parseFloat(shopConfirmResult.totalmoney) - parseFloat(this.recommenditemlist[index].price)
        shopConfirmResult.totalnum = shopConfirmResult.totalnum - 1
      }
      this.recommenditemlist[index].num = num
      // this.recommendmoney = parseInt(this.recommenditemlist[index].num) * parseFloat(this.recommenditemlist[index].price)
      this.recommendnumber = this.recommenditemlist[index].num
      this.recommendmoney =
        parseFloat(this.recommenditemlist[index].price) *
        parseInt(this.recommenditemlist[index].num)
      if (this.recommenditemlist.length) {
        if (isclose == 1) shopConfirmResult.recommendclose = 1
        shopConfirmResult.recommendnum = this.recommenditemlist[index].num
        localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      }
      this.getData()
    },

    closeRecommend(type, index, item) {
      let num = this.recommenditemlist[index].num - 1,
        shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      shopConfirmResult.totalmoney =
        parseFloat(shopConfirmResult.totalmoney) -
        parseFloat(this.recommenditemlist[index].price) * num
      shopConfirmResult.totalnum = shopConfirmResult.totalnum - num
      localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      this.recommenditemlist[index].num = 1
      this.recommendAddToCart(type, index, item, 1)
    },
    // 选择/取消选择
    choice(index, indexB) {
      this.exchangeitemlist[index].changebuylist.map((item, idx) => {
        if (item.ischoose && idx != indexB && item.singlechoose == 1) {
          item.ischoose = 0
        } else if (
          this.exchangeitemlist[index].changebuylist[indexB].ischoose &&
          this.exchangeitemlist[index].changebuylist[indexB].singlechoose == 1 &&
          idx != indexB
        ) {
          item.ischoose = 0
        }
      })
      // (this.exchangetotalNumber + this.exchangeitemlist[index].changebuylist[indexB].num) > this.exchangemaxcanbuycnt && this.exchangeitemlist[index].changebuylist[indexB].ischoose
      if (
        this.exchangeitemlist[index].changebuylist[indexB].num > this.exchangemaxcanbuycnt &&
        this.exchangeitemlist[index].changebuylist[indexB].ischoose
      ) {
        this.exchangeitemlist[index].changebuylist[indexB].ischoose = 0
        this.$toast('超出最大可加购数量')
        return
      }
      this.exchangeitemlist[index].changebuylist[indexB].ischoose = this.exchangeitemlist[index]
        .changebuylist[indexB].ischoose
        ? 1
        : 0
      this.exchangeitemlisttemp = JSON.stringify(this.exchangeitemlist)
      this.count()
    },
    // 计算已选中的商品数量
    count(type) {
      let totalNumber = 0,
        list = this.exchangeitemlist,
        notbuygift_changebuy_money = 0,
        shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult')),
        exchange_morediscountsmoney = 0
      this.exchangechooseitemlist = []
      this.exchangetotalmoney = 0
      if (shopConfirmResult) {
        shopConfirmResult.notbuygift_changebuy_money = 0
      }
      for (let i = 0; i < list.length; i++) {
        let changebuylist = list[i].changebuylist
        for (let j = 0; j < changebuylist.length; j++) {
          if (changebuylist[j].ischoose) {
            this.exchangechooseitemlist.push(changebuylist[j])
            totalNumber += parseInt(changebuylist[j].num)
            this.exchangetotalmoney +=
              parseInt(changebuylist[j].num) * parseFloat(changebuylist[j].changebuy_price)
            if (changebuylist[j].isfullgift == 0 && shopConfirmResult) {
              notbuygift_changebuy_money += changebuylist[j].num * changebuylist[j].changebuy_price
            }
            if (
              changebuylist[j].ismorediscounts &&
              changebuylist[j].num >= changebuylist[j].morediscountsitemnum
            ) {
              if (changebuylist[j].issuperposition != 0) {
                exchange_morediscountsmoney =
                  parseFloat(changebuylist[j].morediscountsmoney) *
                  parseInt(changebuylist[j].num / changebuylist[j].morediscountsitemnum)
              } else {
                exchange_morediscountsmoney = parseFloat(changebuylist[j].morediscountsmoney)
              }
            }
          }
        }
      }
      try {
        this.morediscountsmoney =
          parseFloat(this.morediscounts.morediscountsmoney) + exchange_morediscountsmoney
      } catch (e) {}
      shopConfirmResult.notbuygift_changebuy_money = notbuygift_changebuy_money
      shopConfirmResult.exchangeitemlist = JSON.stringify(list)
      localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      this.exchangetotalNumber = totalNumber
      this.initmoney(type)
      this.getRule(this.integerrule, this.couponlistrule)
      this.giftAct()
      this.getBuygiftRule()
    },
    // 买赠活动
    getBuygiftRule: function () {
      this.buygiftlist = []
      this.buygiftnum = 0
      let ruleList = this.buygiftrule.ruleList
      let isgobuygift = 0 //多买赠活动 赠品存在多选一的情况 0否 1是
      let shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      if (ruleList.length > 0) {
        try {
          ruleList.map((item) => {
            if (item.buygiftlist.length > 1) {
              isgobuygift = 1
              throw new Error()
            }
          })
        } catch (e) {}

        if (
          (shopConfirmResult.isgiftpoponce == 1 && !shopConfirmResult.isbuygiftpoponce) ||
          isgobuygift != 1
        ) {
          shopConfirmResult.buygiftlist = []
        }
        if (
          (shopConfirmResult.isgiftpoponce == 1 && !shopConfirmResult.isbuygiftpoponce) ||
          isgobuygift != 1
        ) {
          shopConfirmResult.buygiftlist_submit = []
        }
        ruleList.map((item) => {
          // 买赠正品只赠一个赠品时
          if (item.buygiftlist.length == 1) {
            // 买赠 首次逻辑的写入
            if (
              (shopConfirmResult.isgiftpoponce == 1 && !shopConfirmResult.isbuygiftpoponce) ||
              isgobuygift != 1
            ) {
              item.choosegiftnum = Number(item.buygiftnum)
              item.buygiftlist[0].num = Number(item.buygiftnum)
              item.buygiftlist[0].isbuygift = 1
              shopConfirmResult.buygiftlist.push(item.buygiftlist[0])
              shopConfirmResult.buygiftlist_submit.push({
                itemid: item.buygiftlist[0].itemid,
                num: item.buygiftlist[0].num
              })
            }
          }
        })
        // 买赠 首次逻辑的写入
        if (
          (shopConfirmResult.isgiftpoponce == 1 && !shopConfirmResult.isbuygiftpoponce) ||
          isgobuygift != 1
        ) {
          this.buygiftrule.ruleList = ruleList
          shopConfirmResult.buygiftrule = this.buygiftrule
          this.buygiftlist = shopConfirmResult.buygiftlist
          this.buygiftlist_submit = shopConfirmResult.buygiftlist_submit
        }
        if (isgobuygift == 1) {
          // 买赠 首次逻辑的写入
          // 弹窗优先级 满赠活动开启未弹先弹满赠，后弹买赠 只弹一次
          if (shopConfirmResult.isgiftpoponce == 1 && !shopConfirmResult.isbuygiftpoponce) {
            shopConfirmResult.isbuygiftpoponce = 1
            this.$dialog
              .confirm({
                message: '恭喜您获得买赠机会，快去选择您想要的赠品吧',
                className: 'collect_button_alert',
                cancelButtonColor: '#FC0324',
                confirmButtonColor: '#FFFCFC',
                confirmButtonText: '去选择',
                cancelButtonText: '取消',
                closeOnPopstate: true
              })
              .then(() => {
                // on confirm
                func()
                this.$router.replace({
                  path: '/freegiftzone_buygift',
                  query: {
                    path: encryption(this.$route.fullPath)
                  }
                })
              })
              .catch(() => {
                // on cancel
                func()
              })
            var func = () => {
              // 默认匹配
              shopConfirmResult.buygiftlist = []
              shopConfirmResult.buygiftlist_submit = []
              ruleList.map((item) => {
                item.choosegiftnum = Number(item.buygiftnum)
                item.buygiftlist[0].num = Number(item.buygiftnum)
                item.buygiftlist[0].isbuygift = 1
                if (item.buygiftlist.length > 1) item.buygiftlist[0].isgolist = 1
                shopConfirmResult.buygiftlist.push(item.buygiftlist[0])
                shopConfirmResult.buygiftlist_submit.push({
                  itemid: item.buygiftlist[0].itemid,
                  num: item.buygiftlist[0].num
                })
              })
              this.buygiftrule.ruleList = ruleList
              shopConfirmResult.buygiftrule = this.buygiftrule
              this.buygiftlist = shopConfirmResult.buygiftlist
              this.buygiftlist_submit = shopConfirmResult.buygiftlist_submit
              this.buygiftlist.map((item) => {
                if (item.num) this.buygiftnum += Number(item.num)
              })
              localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
            }
          } else {
            this.buygiftlist = shopConfirmResult.buygiftlist
            var func = (list) => {
              let tempObj = {}
              list.map((item, index) => {
                let tempgiftitemid = [],
                  tempgiftnum = []
                item.buygiftlist.map((giftitem) => {
                  tempgiftitemid.push(giftitem.itemid)
                  tempgiftnum.push(giftitem.num)
                })
                tempObj[item.itemid] = {
                  buygiftnum: item.buygiftnum,
                  giftitemid: tempgiftitemid,
                  giftnum: tempgiftnum,
                  index: index
                }
              })
              return tempObj
            }
            /************************************************************* */
            // 缓存 买赠规则数据
            let local_buygiftrulelist = func(shopConfirmResult.buygiftrule.ruleList)
            // 实时 买赠规则数据
            let buygiftrulelist = func(this.buygiftrule.ruleList)

            this.buygiftrule.ruleList.map((item) => {
              if (!local_buygiftrulelist.hasOwnProperty(item.itemid)) {
                shopConfirmResult.buygiftrule.ruleList.push(item)
              }
            })
            local_buygiftrulelist = func(shopConfirmResult.buygiftrule.ruleList)

            shopConfirmResult.buygiftrule.ruleList = shopConfirmResult.buygiftrule.ruleList.filter(
              (item) => buygiftrulelist.hasOwnProperty(item.itemid)
            )
            local_buygiftrulelist = func(shopConfirmResult.buygiftrule.ruleList)

            shopConfirmResult.buygiftlist = shopConfirmResult.buygiftlist.filter((item) => {
              for (let key in local_buygiftrulelist) {
                if (local_buygiftrulelist[key].giftitemid.indexOf(item.itemid) >= 0) {
                  return item
                }
              }
            })
            shopConfirmResult.buygiftlist_submit = shopConfirmResult.buygiftlist_submit.filter(
              (item) => {
                for (let key in local_buygiftrulelist) {
                  if (local_buygiftrulelist[key].giftitemid.indexOf(item.itemid) >= 0) {
                    return item
                  }
                }
              }
            )
            shopConfirmResult.buygiftrule.ruleList.map((item) => {
              if (
                // 无选择总数时，说明giftitem.num数量均为0，默认取第一个赠品进行数量递增
                !item.choosegiftnum
              ) {
                item.choosegiftnum = Number(item.buygiftnum)
                item.buygiftlist[0].num = Number(item.buygiftnum)
                item.buygiftlist[0].isbuygift = 1
                if (item.buygiftlist.length > 1) item.buygiftlist[0].isgolist = 1
                shopConfirmResult.buygiftlist.push(item.buygiftlist[0])
                shopConfirmResult.buygiftlist_submit.push({
                  itemid: item.buygiftlist[0].itemid,
                  num: item.buygiftlist[0].num
                })
              } else {
                // 反之 判断实时赠品数量是否与缓存赠品数量一致，不一致则遍历赠品逐个递减赠品数量
                if (item.buygiftnum != buygiftrulelist[item.itemid].buygiftnum) {
                  // tempbuygiftnum 为正：正品数量增；为负：正品数量减
                  let balance = buygiftrulelist[item.itemid].buygiftnum - item.buygiftnum
                  item.choosegiftnum = Number(buygiftrulelist[item.itemid].buygiftnum)
                  item.buygiftnum = buygiftrulelist[item.itemid].buygiftnum
                  let templist = item.buygiftlist
                  for (let i = templist.length - 1; i >= 0; i--) {
                    if (templist[i].num && templist[i].num > 0) {
                      templist[i].num = templist[i].num + balance
                      if (templist[i].num < 0) {
                        balance = templist[i].num
                        templist[i].num = 0
                      } else {
                        balance = 0
                      }
                    }
                  }
                  item.buygiftlist = templist
                  templist.map((tempitem) => {
                    shopConfirmResult.buygiftlist.map((giftitem) => {
                      if (tempitem.itemid == giftitem.itemid) {
                        giftitem.num = tempitem.num
                      }
                    })
                    shopConfirmResult.buygiftlist_submit.map((giftitem) => {
                      if (tempitem.itemid == giftitem.itemid) {
                        giftitem.num = tempitem.num
                      }
                    })
                  })
                }
                shopConfirmResult.buygiftlist = shopConfirmResult.buygiftlist.filter(
                  (item) => item.num && item.num > 0
                )
                shopConfirmResult.buygiftlist_submit = shopConfirmResult.buygiftlist_submit.filter(
                  (item) => item.num && item.num > 0
                )
              }
            })
            this.buygiftlist = shopConfirmResult.buygiftlist
            this.buygiftlist_submit = shopConfirmResult.buygiftlist_submit
            /************************************************************* */
          }
        }

        this.buygiftlist.map((item) => {
          if (item.num) this.buygiftnum += Number(item.num)
        })
      }
      localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
    },
    godetail(items, type) {
      var query = {
        itemid: items.itemid
      }
      if (type != 'recommend') {
        query.type = 'changebuyproductdetail'
      } else {
        this.$commonburiedPoint({
          data: {
            itemid: items.skuid,
            skuid: items.skuid,
            recitemid: items.itemid ? items.itemid : ''
          }
        })
        query.recommend = 1
      }
      this.$router.push({
        path: '/productdetail',
        query: query
      })
    },
    /*
     * 积分预埋开始
     */
    getjifen: function () {
      var that = this
      that.integerlist = []
      that.nouseIntegerlist = []
      var totalprice, choose, coupon
      if (sessionStorage.getItem('choose_integral')) {
        choose = JSON.parse(sessionStorage.getItem('choose_integral'))
        if (sessionStorage.getItem('choose_coupon') && that.couponChecked) {
          coupon = JSON.parse(sessionStorage.getItem('choose_coupon'))
          totalprice = that.totalPrice(that.totalmoney, 0, coupon.price)
        } else {
          totalprice = that.totalPrice(that.totalmoney, 0)
        }
      } else {
        if (sessionStorage.getItem('choose_coupon') && that.couponChecked) {
          coupon = JSON.parse(sessionStorage.getItem('choose_coupon'))
          totalprice = that.totalPrice(that.totalmoney, 0, coupon.price)
        } else {
          totalprice = that.totalmoney
        }
      }
      if (that.integerAllList.length > 0) {
        // 积分规则修改
        that.integerlist = that.integerAllList
        that.nouseIntegerlist = []
        if (sessionStorage.getItem('choose_integral')) {
          that.radio = choose.radio
          that.moneyByIntegral = choose.integermoney
          that.useIntegral = choose.limitinteger
        } else {
          // 总积分和最高档次的积分数进行比较，小的话则将最低档次使用的积分数显示到界面，说明情况
          if (that.integerlist && that.integerlist.length > 0) {
            if (
              parseFloat(that.totalIntegral) >=
              parseFloat(that.integerlist[that.integerlist.length - 1].limitinteger)
            ) {
              that.useIntegral = that.integerlist[that.integerlist.length - 1].limitinteger
              that.moneyByIntegral = that.integerlist[that.integerlist.length - 1].integermoney
              that.radio = that.integerlist.length - 1
              // return
            }
          }
        }
        /* 积分规则修改废弃(勿删)
        that.integerAllList.map(function (item) {
          if (parseInt(that.totalIntegral) > parseInt(item.limitinteger) && parseFloat(totalprice * that.interate) >= parseFloat(item.integermoney)) {
            that.integerlist.unshift(item)
          } else {
            that.nouseIntegerlist.unshift(item)
          }
        })
        if (sessionStorage.getItem('choose_integral')) {
          that.radio = choose.radio
          that.moneyByIntegral = choose.integermoney
          that.useIntegral = choose.limitinteger
        } else {
          // 总积分和最高档次的积分数进行比较，小的话则将最低档次使用的积分数显示到界面，说明情况
          if (that.integerlist && that.integerlist.length > 0) {
            if (parseFloat(that.totalIntegral) >= parseFloat(that.integerlist[that.integerlist.length - 1].limitinteger)) {
              that.useIntegral = that.integerlist[that.integerlist.length - 1].limitinteger
              that.moneyByIntegral = that.integerlist[that.integerlist.length - 1].integermoney
              that.radio = that.integerlist.length - 1
              // return
            }
          }
        }
        */
        // else {
        //     //判断可用积分档次,不符合不需要处理
        //     var pricetotal = this.totalmoney
        //     //当商品参与折上折并且折上折活动正在进行
        //     // if (that.isdiscount == 1 && that.discountrule.discountenable == 1) {
        //     //   pricetotal = pricetotal - that.discountmoney
        //     // }
        //     //进行积分档次循环（因为档次返回是按照从高到底的，只要第一个满足积分使用条件进行赋值跳出循环就行）
        //     for (var i = 0; i < that.integerlist.length; i++) {
        //       //判断可用积分档次,不符合不需要处理
        //       if (parseFloat(that.integerlist[i].integermoney) <= parseFloat(pricetotal * that.interate)) {
        //         that.useIntegral = that.integerlist[i].limitinteger
        //         that.moneyByIntegral = that.integerlist[i].integermoney
        //         // break
        //       }
        //     }
        //   }
      }
      this.totalMoney()
    },
    switchIntegralFn: function (checked, ismutex) {
      this.saveIntegral(checked, ismutex)
      this.checkProduct()
    },
    integralRule: function () {
      var rule = ''
      this.integralrule.map(function (item, index) {
        rule = rule + parseInt(index + 1) + '.' + item + '\r'
      })

      this.$dialog
        .alert({
          title: '金币使用规则',
          message: rule,
          className: 'percen_button_alert integral_button_alert',
          confirmButtonColor: '#FFFCFC',
          confirmButtonText: '我知道了',
          closeOnPopstate: false
        })
        .then(function () {
          // on confirm
        })
    },
    saveIntegral: function (check, ismutex) {
      var integralObj = {}
      if (check && this.radio != null) {
        this.moneyByIntegral = this.integerlist[this.radio].integermoney
        this.useIntegral = this.integerlist[this.radio].limitinteger
        integralObj = {
          checked: check,
          radio: this.radio,
          limitinteger: this.integerlist[this.radio].limitinteger,
          integermoney: this.integerlist[this.radio].integermoney
        }
        sessionStorage.setItem('choose_integral', JSON.stringify(integralObj))
      } else if (!check && this.radio != null) {
        sessionStorage.removeItem('choose_integral')
      }
      if (this.ispreferentialmutex == 1 && ismutex != 0 && this.couponChecked) {
        this.couponChecked = false
        this.couponFn(0)
      } else {
        this.totalMoney()
        this.getjifen()
        this.loadcoupons()
      }
    },
    xierSort: function (arr) {
      var interval = parseInt(arr.length / 2) // 分组间隔设置
      while (interval > 0) {
        for (var i = 0; i < arr.length; i++) {
          var n = i
          while (
            arr[n - interval] &&
            parseFloat(arr[n].price) > parseFloat(arr[n - interval].price) &&
            n > 0
          ) {
            var temp = JSON.stringify(arr[n])
            arr[n] = arr[n - interval]
            arr[n - interval] = JSON.parse(temp)
            n = n - interval
          }
        }
        interval = parseInt(interval / 2)
      }
      return arr
    },
    /**
     * 满赠活动
     **/
    giftAct: function () {
      if (
        this.fullgift &&
        JSON.stringify(this.fullgift) != '{}' &&
        this.fullgift.list &&
        this.fullgift.list.length
      ) {
        if (this.fullgiftrulenew && this.fullgiftrulenew.length) {
          this.giftruleCalculate()
        }
        if (this.isgiftpop == 1) {
          this.giftpopup()
        } else {
          var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
          shopConfirmResult.isgiftpoponce = 1
          localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
        }
      } else {
        var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
        shopConfirmResult.isgiftpoponce = 1
        localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      }
    },
    giftpopup: function () {
      var that = this
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      if (this.fullgift.actpopdesc) {
        if (!shopConfirmResult.isgiftpoponce) {
          shopConfirmResult.isgiftpoponce = 1
          localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
          this.$dialog
            .confirm({
              message: '恭喜您获得满赠机会，快去选择您想要的赠品吧',
              className: 'collect_button_alert',
              cancelButtonColor: '#FC0324',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '去选择',
              cancelButtonText: '取消',
              closeOnPopstate: true
            })
            .then(function () {
              // on confirm
              shopConfirmResult.isbuygiftpoponce = 1
              localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
              that.$router.replace({
                path: '/freeGiftZone',
                query: {
                  path: encryption(that.$route.fullPath)
                }
              })
            })
            .catch(function () {
              // on cancel
              shopConfirmResult.isbuygiftpoponce = 1
              localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
              that.getBuygiftRule() // 买赠活动
            })
        } else {
          var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
          shopConfirmResult.isbuygiftpoponce = 1
          localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
        }
      }
    },
    giftruleCalculate: function () {
      var that = this
      var ischoose = 0
      that.giftmoney = 0
      that.isgiftpop = 0
      that.giftactid = ''
      that.giftitem = ''
      that.giftnum = 0
      that.list = JSON.parse(that.listtemp)
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult')),
        notbuygift_changebuy_money = shopConfirmResult.notbuygift_changebuy_money
          ? shopConfirmResult.notbuygift_changebuy_money
          : 0
      var list = that.fullgift.list ? that.fullgift.list : []
      for (var i = list.length - 1; i >= 0; i--) {
        // 总金额是否满足当前满赠档位
        if (
          parseFloat(list[i].allmoney) <=
          parseFloat(
            (
              parseFloat(that.paymoney - notbuygift_changebuy_money) - parseFloat(list[i].notmoney)
            ).toFixed(2)
          )
        ) {
          var itemlist = list[i].giftlist
          if (shopConfirmResult.gift_list && JSON.parse(shopConfirmResult.gift_list)) {
            var giftlist = JSON.parse(shopConfirmResult.gift_list)[0]
            if (giftlist.giftid != list[i].giftid) {
              shopConfirmResult.gift_choose_skuid = ''
            }
          }
          shopConfirmResult.gift_list = JSON.stringify([list[i]])
          for (var j = 0; j < itemlist.length; j++) {
            // 判断是否有选中的skuid
            if (!shopConfirmResult.gift_choose_skuid) {
              if (itemlist[j].ischoose == 1) {
                ischoose = 1
                shopConfirmResult.gift_choose_skuid = itemlist[j].skuid
                itemlist[j].isgiftproduct = 1
                itemlist[j].gift_act_name = that.fullgift.actdesc
                if (itemlist.length > 1) {
                  itemlist[j].isgolist = 1
                } else {
                  itemlist[j].isgolist = 0
                }
                that.giftmoney = that.giftmoney + itemlist[j].price * itemlist[j].num
                that.giftactid = list[i].giftid
                that.giftitem = itemlist[j].skuid
                that.giftnum = parseInt(itemlist[j].num)
                that.list.push(itemlist[j])
                if (itemlist.length > 1) {
                  that.isgiftpop = 1
                }
                break
              }
            } else {
              if (
                shopConfirmResult.gift_choose_skuid == itemlist[j].skuid &&
                itemlist[j].ischoose == 1
              ) {
                ischoose = 1
                itemlist[j].isgiftproduct = 1
                itemlist[j].gift_act_name = that.fullgift.actdesc
                if (itemlist.length > 1) {
                  itemlist[j].isgolist = 1
                } else {
                  itemlist[j].isgolist = 0
                }
                that.giftmoney = that.giftmoney + itemlist[j].price * itemlist[j].num
                that.giftactid = list[i].giftid
                that.giftitem = itemlist[j].skuid
                that.giftnum = parseInt(itemlist[j].num)
                that.list.push(itemlist[j])
                if (itemlist.length > 1) {
                  that.isgiftpop = 1
                }
                break
              }
            }
          }
          localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
          break
        } else {
          ischoose = 0
          if (shopConfirmResult.hasOwnProperty('gift_list')) {
            delete shopConfirmResult['gift_list']
          }
          if (shopConfirmResult.hasOwnProperty('gift_choose_skuid')) {
            delete shopConfirmResult['gift_choose_skuid']
          }
        }
        if (ischoose == 1) {
          break
        }
      }
      if (ischoose != 1) {
        var index = null
        that.list.map(function (item, i) {
          if (item.isgiftproduct == 1) {
            index = i
          }
        })
        if (index != null) {
          that.list.splice(index, 1)
          that.totalmoney = that.totalmoney - that.giftmoney
          that.totalprice = that.totalmoney
          that.giftmoney = 0
        }
        that.totalnum = 0
        that.totalnumshow = 0
        that.birthdaygifttotalnum = 0
        that.itemids = []
        that.list.map(function (item) {
          if (
            item.isgift != 1 &&
            (item.ismorediscounts != 1 || (item.ismorediscounts == 1 && item.couponsenable == 1))
          ) {
            let moredismoney = 0
            if (item.ismorediscounts == 1 && item.num >= item.morediscountsitemnum) {
              if (item.issuperposition != 0) {
                moredismoney =
                  parseFloat(item.morediscountsmoney) * parseInt(item / item.morediscountsitemnum)
              } else {
                moredismoney = parseFloat(item.morediscountsmoney)
              }
            }
            that.itemids.push({
              id: item.skuid,
              num: item.num && parseInt(item.num) >= 0 ? item.num : 1,
              price: item.price,
              isdiscount: item.isdiscount,
              moredismoney: moredismoney || 0,
              fullminusmoney: 0
            })
          }
          that.totalnum =
            that.totalnum + parseInt(item.num && parseInt(item.num) >= 0 ? item.num : 1)
          that.totalnumtemp = that.totalnum
          if (item.isintellrecommend != 1) {
            that.totalnumshow =
              that.totalnumshow + parseInt(item.num && parseInt(item.num) >= 0 ? item.num : 1)
          }
          if (item.isbirthdaygift == 1) {
            that.birthdaygifttotalnum += parseInt(
              item.num && parseInt(item.num) >= 0 ? item.num : 1
            )
          }
        })
        that.exchangechooseitemlist.map(function (item) {
          if (item.ismorediscounts != 1 || (item.ismorediscounts == 1 && item.couponsenable == 1)) {
            let moredismoney = 0
            if (item.ismorediscounts == 1 && item.num >= item.morediscountsitemnum) {
              if (item.issuperposition != 0) {
                moredismoney =
                  parseFloat(item.morediscountsmoney) * parseInt(item / item.morediscountsitemnum)
              } else {
                moredismoney = parseFloat(item.morediscountsmoney)
              }
            }
            that.itemids.push({
              id: item.skuid,
              num: item.num && parseInt(item.num) >= 0 ? item.num : 1,
              price: item.changebuy_price,
              isdiscount: item.isdiscount,
              moredismoney: moredismoney || 0,
              fullminusmoney: 0
            })
          }
        })
        if (that.itemids.length) {
          that.fullminusdiscountFn()
        }
      }
    },
    /**
     * 产品劵显示
     **/
    getProduct: function () {
      var that = this
      if (sessionStorage.getItem('choose_product')) {
        var chooseproduct = JSON.parse(sessionStorage.getItem('choose_product'))
        var index = null
        that.productgify = chooseproduct
        try {
          that.totalnum = that.totalnum + [that.productgify.goodsinfo].length
        } catch (e) {
          console.log(e)
        }
        that.producttitle = JSON.parse(sessionStorage.getItem('choose_product')).name
        for (var i = 0; i < that.productlist.length; i++) {
          if (chooseproduct.id == that.productlist[i].id) {
            index = i
            break
          }
        }
        that.chooseProduct(index)
      } else {
        that.chooseProduct(0)
        that.comfrimProduct()
      }
      that.productcount = that.productlist.length > 0 ? that.productlist.length : 0
    },
    showProduct: function () {
      var that = this
      this.showproduct = true
      setTimeout(function () {
        that.productBtn = true
      }, 500)
    },
    closeProduct: function () {
      this.showproduct = false
      this.productBtn = false
    },
    chooseProduct: function (index) {
      var items = []
      var that = this
      that.productlist.forEach(function (item, i) {
        if (i === index) {
          if (item.isChoose) {
            item.isChoose = false
            that.productPrice = 0
            that.chooseProductIndex = null
          } else {
            item.isChoose = true
            that.chooseProductIndex = i
          }
        } else {
          item.isChoose = false
        }
        items.push(item)
      })
      that.productlist = items
    },
    showProductDesc: function (index) {
      var productShowList = []
      this.productlist.map(function (item, i) {
        if (index == i) {
          item.isShowDesc = !item.isShowDesc
        }
        productShowList.push(item)
      })
      this.productlist = productShowList
    },
    comfrimProduct: function () {
      this.showproduct = false
      var product = this.productlist[this.chooseProductIndex]
      if (product != undefined && product != '' && product != null) {
        sessionStorage.setItem('choose_product', JSON.stringify(product))
        this.productgify = product
        try {
          this.totalnum = this.totalnum + [this.productgify.goodsinfo].length
        } catch (e) {
          console.log(e)
        }
        this.totalnumshow = this.totalnum
        this.producttitle = product.name
      } else {
        sessionStorage.removeItem('choose_product')
        this.productgify = null
        this.totalnum = this.totalnumtemp
        this.totalnumshow = this.totalnum
        this.producttitle = ''
      }
    },
    /**
     * 优惠券计算
     **/
    switchCouponFn: function (ismutex) {
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      shopConfirmResult.init_coupon_data = 1
      localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      this.couponFn(ismutex)
    },
    couponFn: function (ismutex) {
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      shopConfirmResult.couponChecked = this.couponChecked // 无选择的现金券时按钮开关状态需缓存至shopConfirmResult
      localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      if (this.localCoupon) {
        this.localCoupon.checked = this.couponChecked
        if (this.couponChecked) {
          this.couponPrice = this.localCoupon.price
        } else {
          this.couponPrice = 0
          // sessionStorage.removeItem('choose_coupon')
        }
        sessionStorage.setItem('choose_coupon', JSON.stringify(this.localCoupon))
      }
      if (this.ispreferentialmutex == 1 && ismutex != 0 && this.integralChecked) {
        this.integralChecked = false
        this.switchIntegralFn(this.integralChecked, 0)
      } else {
        this.totalMoney()
        this.getjifen()
        this.loadcoupons()
      }
      this.checkProduct()
    },
    loadcoupons: function () {
      console.log(this.itemids)
      var that = this
      // var ids = that.itemids //需要购买的商品id（一组或者一个，都按照一组来处理）
      this.usecouponlist = []
      this.nousercouponlist = []
      var totalprice, choose, integral
      if (sessionStorage.getItem('choose_coupon') && this.couponChecked) {
        choose = JSON.parse(sessionStorage.getItem('choose_coupon'))
        if (sessionStorage.getItem('choose_integral')) {
          integral = JSON.parse(sessionStorage.getItem('choose_integral'))
          if (integral.checked == true) {
            totalprice = that.totalPrice(that.totalmoney, 0, integral.integermoney)
          }
        } else {
          totalprice = that.totalPrice(that.totalmoney, 0)
        }
      } else {
        if (sessionStorage.getItem('choose_integral')) {
          integral = JSON.parse(sessionStorage.getItem('choose_integral'))
          if (integral.checked == true) {
            totalprice = that.totalPrice(that.totalmoney, 0, integral.integermoney)
          }
        } else {
          totalprice = that.totalmoney
        }
      }
      if (that.discountrule.discountenable == 1 && that.discountrule.couponsenable == 0) {
        totalprice = 0
      }
      // 当获取的优惠券列表存在，进行逻辑处理
      if (that.couponlist.length > 0) {
        // 进行所有优惠券的循环遍历筛选
        for (var i = 0; i < that.couponlist.length; i++) {
          // 过滤掉优惠券金额大于订单总金额乘以优惠比例上限的情况
          if (
            parseFloat(that.couponlist[i].price) >
            parseFloat(totalprice * that.couponlist[i].couponuserate)
          ) {
            that.nousercouponlist.push(that.couponlist[i])
          } else {
            if (that.couponlist[i].rangetype == '1') {
              // 指定商品，
              if (
                that.couponlist[i].items != null &&
                that.couponlist[i].items != undefined &&
                that.couponlist[i].items != ''
              ) {
                // 指定商品存在的情况
                var hascount = 0 // 是否存在购买商品

                var money = 0 // 商品总金额

                // for (var j = 0; j < ids.length; j++) {//循环遍历，在优惠券指定的一组商品中查找购买的商品id是否符合要求
                //   if ((',' + that.couponlist[i].items + ',').indexOf(',' + ids[j] + ',') > -1) {
                //     hascount++
                //   }
                // }
                for (var j = 0; j < that.itemids.length; j++) {
                  // 循环遍历，在优惠券指定的一组商品中查找购买的商品id是否符合要求
                  if (
                    (',' + that.couponlist[i].items + ',').indexOf(',' + that.itemids[j].id + ',') >
                    -1
                  ) {
                    hascount++
                    if (that.itemids[j].isdiscount == 1) {
                      money =
                        money +
                        (that.itemids[j].price * that.itemids[j].num -
                          that.itemids[j].moredismoney -
                          that.itemids[j].fullminusmoney) *
                          that.currentdiscount
                    } else {
                      money =
                        money +
                        (that.itemids[j].price * that.itemids[j].num -
                          that.itemids[j].moredismoney -
                          that.itemids[j].fullminusmoney)
                    }
                  }
                }
                if (integral && integral.checked == true) {
                  money = money - parseFloat(integral.integermoney)
                }
                if (that.couponlist[i].coupontype == '1') {
                  // 现金券
                  if (hascount > 0 && that.itemids.length > 0) {
                    // 符合使用条件
                    that.usecouponlist.push(that.couponlist[i])
                  } else {
                    // 不符合使用条件
                    that.nousercouponlist.push(that.couponlist[i])
                  }
                } else if (that.couponlist[i].coupontype == '2') {
                  // 满减券
                  if (
                    parseFloat(money) >= parseFloat(that.couponlist[i].fullprice) &&
                    hascount > 0 &&
                    that.itemids.length > 0
                  ) {
                    that.usecouponlist.push(that.couponlist[i])
                  } else {
                    that.nousercouponlist.push(that.couponlist[i])
                  }
                }
              } else {
                // 没有指定任何商品的情况；当然这种情况正常情况下不会存在
                that.nousercouponlist.push(that.couponlist[i])
              }
            } else if (that.couponlist[i].rangetype == '0') {
              // 全场通用
              var hascount = 0 // 购买商品里是否存在不可用优惠券的商品
              var money = 0 // 商品总金额

              // for (var j = 0; j < ids.length; j++) {//循环遍历，在优惠券指定的一组商品中查找购买的商品id是否符合要求
              //   if ((',' + that.couponlist[i].notitems + ',').indexOf(',' + ids[j] + ',') > -1) {
              //     hascount++
              //   }
              // }
              for (var j = 0; j < that.itemids.length; j++) {
                // 循环遍历，在优惠券指定的一组商品中查找购买的商品id是否符合要求
                if (that.itemids[j].isdiscount == 1) {
                  money =
                    money +
                    (that.itemids[j].price * that.itemids[j].num -
                      that.itemids[j].moredismoney -
                      that.itemids[j].fullminusmoney) *
                      that.currentdiscount
                } else {
                  money =
                    money +
                    (that.itemids[j].price * that.itemids[j].num -
                      that.itemids[j].moredismoney -
                      that.itemids[j].fullminusmoney)
                }
                if (that.couponlist[i].items == '') {
                  if (
                    (',' + that.couponlist[i].notitems + ',').indexOf(
                      ',' + that.itemids[j].id + ','
                    ) > -1
                  ) {
                    hascount++
                    if (that.itemids[j].isdiscount == 1) {
                      money =
                        money -
                        (that.itemids[j].price * that.itemids[j].num -
                          that.itemids[j].moredismoney -
                          that.itemids[j].fullminusmoney) *
                          that.currentdiscount
                    } else {
                      money =
                        money -
                        (that.itemids[j].price * that.itemids[j].num -
                          that.itemids[j].moredismoney -
                          that.itemids[j].fullminusmoney)
                    }
                  }
                } else if (that.couponlist[i].items != '') {
                  if (
                    (',' + that.couponlist[i].notitems + ',').indexOf(
                      ',' + that.itemids[j].id + ','
                    ) > -1
                  ) {
                    hascount++
                    if (that.itemids[j].isdiscount == 1) {
                      money =
                        money -
                        (that.itemids[j].price * that.itemids[j].num -
                          that.itemids[j].moredismoney -
                          that.itemids[j].fullminusmoney) *
                          that.currentdiscount
                    } else {
                      money =
                        money -
                        (that.itemids[j].price * that.itemids[j].num -
                          that.itemids[j].moredismoney -
                          that.itemids[j].fullminusmoney)
                    }
                  } else if (
                    (',' + that.couponlist[i].items + ',').indexOf(
                      ',' + that.itemids[j].id + ','
                    ) <= -1
                  ) {
                    hascount++
                    if (that.itemids[j].isdiscount == 1) {
                      money =
                        money -
                        (that.itemids[j].price * that.itemids[j].num -
                          that.itemids[j].moredismoney -
                          that.itemids[j].fullminusmoney) *
                          that.currentdiscount
                    } else {
                      money =
                        money -
                        (that.itemids[j].price * that.itemids[j].num -
                          that.itemids[j].moredismoney -
                          that.itemids[j].fullminusmoney)
                    }
                  }
                }
              }
              if (integral && integral.checked == true) {
                money = money - parseFloat(integral.integermoney)
              }
              if (that.couponlist[i].coupontype == '1') {
                if ((hascount > 0 && that.itemids.length <= hascount) || that.itemids.length <= 0) {
                  // 存在
                  that.nousercouponlist.push(that.couponlist[i])
                } else {
                  // 不符合使用条件
                  that.usecouponlist.push(that.couponlist[i])
                }
              } else if (that.couponlist[i].coupontype == '2') {
                if (
                  parseFloat(money) >= parseFloat(that.couponlist[i].fullprice) &&
                  that.itemids.length > hascount &&
                  that.itemids.length > 0
                ) {
                  // 不存在并且商品总金额满足满减券条件
                  that.usecouponlist.push(that.couponlist[i])
                } else {
                  that.nousercouponlist.push(that.couponlist[i])
                }
              }
            }
          }
        }
      }
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      if (that.iszg != 1 && that.yl != 1 && that.ms != 1 && that.ylact != 1) {
        that.usecouponlist.map(function (item) {
          if (choose) {
            if (item.couponid == choose.couponid) {
              item.isChoose = true
            } else {
              item.isChoose = false
            }
          } else {
            item.isChoose = false
          }
          item.isShowDesc = false
        })
        that.nousercouponlist.map(function (item) {
          item.isChoose = false
          item.isShowDesc = false
          if (sessionStorage.getItem('choose_coupon')) {
            let chooseCoupon = JSON.parse(sessionStorage.getItem('choose_coupon'))
            if (chooseCoupon.couponid == item.couponid) {
              that.couponstitle = ''
              that.localCoupon = null
              sessionStorage.removeItem('choose_coupon')
            }
          }
        })
        that.usablecount = that.usecouponlist.length >= 0 ? that.usecouponlist.length : 0
        that.xierSort(that.usecouponlist)
        if (that.ispreferentialmutex == 1 && this.integralChecked) {
          return
        }
        if (
          !sessionStorage.getItem('choose_coupon') &&
          that.usecouponlist.length &&
          !shopConfirmResult.init_coupon_data
        ) {
          if (that.usecouponlist[0].isChoose) {
            that.usecouponlist[0].isChoose = false
            that.couponPrice = 0
            that.chooseUsecouponIndex = null
          } else {
            that.usecouponlist[0].isChoose = true
            that.couponPrice = parseFloat(that.usecouponlist[0].price).toFixed(2)
            that.chooseUsecouponIndex = 0
          }

          this.localCoupon = that.usecouponlist[0]
          this.couponChecked = true
          this.localCoupon.checked = this.couponChecked
          sessionStorage.setItem('choose_coupon', JSON.stringify(that.usecouponlist[0]))
        } else {
          var coupontemp =
            sessionStorage.getItem('choose_coupon') && this.couponChecked
              ? JSON.parse(sessionStorage.getItem('choose_coupon'))
              : null
          if (coupontemp != null) {
            that.couponPrice = parseFloat(coupontemp.price).toFixed(2)
          } else if (that.usecouponlist.length > 0 && !shopConfirmResult.init_coupon_data) {
            sessionStorage.setItem('choose_coupon', JSON.stringify(that.usecouponlist[0]))
            that.usecouponlist[0].isChoose = true
            that.couponPrice = parseFloat(that.usecouponlist[0].price).toFixed(2)
            that.chooseUsecouponIndex = 0
            that.couponstitle =
              that.usecouponlist[0].couponname + ' ￥' + parseFloat(that.usecouponlist[0].price)
          }
        }
      } else {
        that.usablecount = that.usecouponlist.length >= 0 ? that.usecouponlist.length : 0
      }
      that.totalMoney()
    },
    showCoupon: function () {
      if (!this.couponChecked) return
      var that = this
      if (
        (this.usecouponlist && this.usecouponlist.length > 0) ||
        (this.nousercouponlist && this.nousercouponlist.length > 0)
      ) {
        this.showcoupon = true
        var choose = sessionStorage.getItem('choose_coupon')
          ? JSON.parse(sessionStorage.getItem('choose_coupon'))
          : null
        if (choose) {
          that.usecouponlist.map(function (item) {
            if (choose) {
              if (item.couponid == choose.couponid) {
                item.isChoose = true
                that.couponPrice = choose.price
              } else {
                item.isChoose = false
              }
            } else {
              item.isChoose = false
            }
            item.isShowDesc = false
          })
        }
        setTimeout(function () {
          that.couponBtn = true
        }, 500)
      }
    },
    closeCoupon: function () {
      this.showcoupon = false
      this.couponBtn = false
    },
    // closeIntegral: function () {
    //   this.showintegral = false
    // },
    // showIntegral: function () {
    //   this.showintegral = true
    // },
    // handleAddOrder: function () {
    //   this.goNext()
    //   this.showflodmsg = false
    // },
    // handleCancelFlod: function () {
    //   this.showflodmsg = false
    // },
    handleShowsubscribegoodsOrder: function () {
      this.goNext()
      this.showsubscribegoodsmsg = false
    },
    handleCancelShowsubscribegoods: function () {
      this.showsubscribegoodsmsg = false
      window.location = '/static/wx/html/fullGift/index.html?type=addorder&is_subscribegoods=1'
    },
    handleAddFiveHundOrder: function () {
      this.goNext()
      this.showFiveHundmsg = false
    },
    handleCancelFiveHund: function () {
      this.showFiveHundmsg = false
      this.$router.replace({
        path: '/classification',
        query: {
          type: 'inside'
        }
      })
    },
    handleCancelEightHund: function () {
      this.showEightHundmsg = false
      this.$router.replace({
        path: '/classification',
        query: {
          type: 'inside'
        }
      })
    },
    handleAddEightHundOrder: function () {
      this.goNext()
      this.showEightHundmsg = false
    },
    handleAddress: function () {
      this.address()
      this.showaddress = false
    },
    handleEditorAddress: function () {
      this.editaddressFn()
      this.showaddress = false
    },
    handlePay: function () {
      this.goNext()
      this.showaddress = false
    },
    goNext: function () {
      var that = this
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      if (!this.addressVal.id) {
        this.$toast('请添加收货地址再提交')
        return
      }
      if (!this.ischeckaddress) {
        this.isaddressFn()
          .then((res) => {
            that.ischeckaddress = true
            f()
          })
          .catch((err) => {
            if (err.data.code == 2002) {
              this.$dialog
                .alert({
                  title: '温馨提示',
                  message: err.data.msg,
                  messageAlign: 'left',
                  className: 'percen_button_alert integral_button_alert',
                  confirmButtonColor: '#FFFCFC',
                  confirmButtonText: '我知道了',
                  closeOnPopstate: false
                })
                .then(function () {
                  // on confirm
                })
            } else {
              this.$dialog
                .confirm({
                  title: '温馨提示',
                  message: err.data.msg,
                  messageAlign: 'left',
                  className: 'collect_button_alert',
                  cancelButtonColor: '#FC0324',
                  confirmButtonColor: '#FFFCFC',
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  closeOnPopstate: true
                })
                .then(function () {
                  // on confirm
                  that.ischeckaddress = true
                  f()
                })
                .catch(function () {
                  // on cancel
                })
            }
          })
      } else {
        f()
      }
      function f() {
        if (that.is_50vipentrance == 1 && !that.ismobile) {
          that.ismobile = true
          that.$nextTick(function () {
            that.getCodeImg()
          })
          return
        }
        if (that.ismobile) {
          that.ismobile = false
          that.is_50vipentrance = 0
        }
        var url = that.$ajax.addOrder_URL
        if (that.$route.query.np == 1) {
          url = that.$ajax.addOrderBySpike_URL
        } else if (that.$route.query.yl == 1 && that.$route.query.lb != 1) {
          if (that.$route.query.ylcc == 9) {
            url = that.$ajax.addLiveOrder_URL
          } else if (that.$route.query.ann == 1) {
            url = that.$ajax.addOrder_YearActivity_URL
          } else if (that.$route.query.anncc == 1) {
            url = that.$ajax.addOrderBySpecail_URL
          } else if (that.$route.query.mtact == 1) {
            url = that.$ajax.addChoiceItemOrder_URL
          } else if (that.$route.query.prize == 1) {
            url = that.$ajax.addOrderByPrizes_URL
          } else if (that.$route.query.defectivegood == 1) {
            url = that.$ajax.addOrderByWxp_URL
          } else if (that.$route.query.acttype == 'hc_welfare') {
            url = that.$ajax.addOrder_OfflineActivity_URL
          } else {
            url = that.$ajax.addActOrder_URL
          }
        } else if (that.$route.query.ms == 1) {
          // 秒杀 msindex
          url = that.$ajax.addLimitActOrder_URL
        } else if (that.$route.query.yl == 1 && that.$route.query.lb == 1) {
          url = that.$ajax.addJzGiftActOrder_URL
        } else if (that.$route.query.ylact == 1) {
          if (that.$route.query.newpersonact == 1) {
            url = that.$ajax.addNewUserOrder_URL
          } else {
            url = that.$ajax.addDrainageActivityOrder_URL
          }
        } else if (shopConfirmResult.isgiftbagbuy == 1) {
          // 线下会议礼包 exclusive-gift.html
          url = that.$ajax.addOrder_InformalemplMeeting_URL
        }

        var skuids = [],
          recommendskuids = [],
          buynum = [],
          recommendbuynum = [],
          live_id = [],
          room_id = [],
          len = 0,
          isdiscount = 0,
          floditemnum = 0,
          data,
          couponsid,
          integernumber,
          integermoney,
          list = clone(that.list),
          recitemid = []
        if (that.exchangeitemlist.length) {
          list = list.concat(
            that.exchangeitemlist[0].changebuylist.filter(
              (item) => item.ischoose == true || item.ischoose == 1
            )
          )
        }
        list.map(function (item) {
          if (item.isgift != 1 && item.is_subscribegoods != 1) {
            if (item.isoversea == 1) {
              len++
            }
            if (item.isdiscount == 1) {
              isdiscount = 1
              floditemnum += parseInt(item.num)
            }
            if (item.isgiftproduct != 1 && item.isintellrecommend != 1) {
              skuids.push(item.skuid)
              buynum.push(item.num)
              live_id.push(item.liveid)
              // room_id.push(item.roomid); // 获取商品接口暂时不返
            }
            if (item.isintellrecommend == 1) {
              let index = skuids.indexOf(item.skuid)
              if (index >= 0) {
                buynum[index] = buynum[index] + item.num
              } else {
                recommendskuids.push(item.skuid)
                recommendbuynum.push(item.num)
                recitemid.push(item.itemid)
              }
            }
          }
        })
        if (that.productgify != null) {
          ;[that.productgify.goodsinfo].map(function (item) {
            skuids.push(item.skuid)
            buynum.push(item.num)
            live_id.push(0)
          })
        }
        if (shopConfirmResult.roomId) room_id = shopConfirmResult.roomId

        that.currentdiscountIndex =
          that.currentdiscountIndex == -1
            ? that.discountrule.discountlist.length
            : that.currentdiscountIndex
        // if (that.currentdiscountIndex > 0 && isdiscount == 1 && that.discountrule.discountenable == 1 && Number(localStorage.getItem('discountflag')) != 1 && floditemnum > 0) {
        //   that.flodnum = parseInt(that.discountrule.discountlist[that.currentdiscountIndex - 1].itemnum) - floditemnum
        //   var discount = that.discountrule.discountlist[that.currentdiscountIndex - 1].discount
        //   that.flodtxt = (discount * 100) % 10 == 0 ? ((discount * 100) / 10) : discount * 100
        //   localStorage.setItem('discountflag', 1)
        //   that.showflodmsg = true
        //   return
        // }
        if (that.subscribegoodsrule.tips && localStorage.getItem('showsubscribegoods') != 1) {
          localStorage.setItem('showsubscribegoods', 1)
          that.showsubscribegoodsmsg = true
          return
        }
        if (
          that.couponstips.showtips == 1 &&
          Number(localStorage.getItem('fivehundred')) != 1 &&
          parseFloat(that.totalprice) < parseFloat(that.couponstips.money) &&
          that.couponstips.tips
        ) {
          localStorage.setItem('fivehundred', 1)
          that.showFiveHundmsg = true
          return
        }
        if (
          that.drawprizetips.showtips == 1 &&
          Number(localStorage.getItem('eighthundred')) != 1 &&
          ((that.couponstips.showtips == 1 &&
            parseFloat(that.totalprice) >= parseFloat(that.couponstips.money)) ||
            that.couponstips.showtips == 0) &&
          parseFloat(that.totalprice) < parseFloat(that.drawprizetips.money) &&
          that.drawprizetips.tips
        ) {
          localStorage.setItem('eighthundred', 1)
          that.showEightHundmsg = true
          return
        }
        if (that.addressVal.mobile) {
          let str = that.addressVal.mobile
          if (/ /g.test(str) || !/^1[3456789]\d{9}$/.test(str)) {
            that.$toast('请检查收货人手机号码是否正确')
            return
          }
        }
        if (!that.discountaddress) {
          that.showaddress = true
          that.discountaddress = 1
          return
        }
        if (sessionStorage.getItem('choose_coupon') && that.couponChecked) {
          if (sessionStorage.getItem('choose_integral')) {
            couponsid = JSON.parse(sessionStorage.getItem('choose_coupon')).couponid
            integernumber = JSON.parse(sessionStorage.getItem('choose_integral')).limitinteger
            integermoney = JSON.parse(sessionStorage.getItem('choose_integral')).integermoney
          } else {
            couponsid = JSON.parse(sessionStorage.getItem('choose_coupon')).couponid
            integernumber = ''
            integermoney = ''
          }
        } else {
          if (sessionStorage.getItem('choose_integral')) {
            couponsid = ''
            integernumber = JSON.parse(sessionStorage.getItem('choose_integral')).limitinteger
            integermoney = JSON.parse(sessionStorage.getItem('choose_integral')).integermoney
          } else {
            couponsid = ''
            integernumber = ''
            integermoney = ''
          }
        }
        data = {
          remark: that.remark != null || that.remark != undefined ? that.remark : '',
          addressid: that.addressVal.id,
          skuids: skuids.join() + (recommendskuids.length > 0 ? ',' + recommendskuids.join() : ''),
          buynum: buynum.join() + (recommendbuynum.length > 0 ? ',' + recommendbuynum.join() : ''),
          live_id: live_id.join(),
          room_id: room_id.length ? room_id.join() : '',
          orderid: shopConfirmResult.orderid ? shopConfirmResult.orderid : '',
          ysorderid: shopConfirmResult.ysorderid ? shopConfirmResult.ysorderid : '',
          useintegralitemjson: that.useintegralitemjson || ''
        }

        if (shopConfirmResult.specialid) {
          data.specialid = shopConfirmResult.specialid
        }
        if (shopConfirmResult.orderfrom || shopConfirmResult.orderfrom == 0) {
          data.from = shopConfirmResult.orderfrom
        }
        if (shopConfirmResult.groupbuyid) {
          data.groupbuyid = shopConfirmResult.groupbuyid
        }
        if (shopConfirmResult.receivmethod) {
          data.receivmethod = shopConfirmResult.receivmethod
        }
        if (that.mobile.trim()) data.upck50_mobile = that.mobile
        if (shopConfirmResult.course_params) {
          data.course_params = shopConfirmResult.course_params.join()
        }
        if (that.buygiftlist_submit && that.buygiftlist_submit.length > 0) {
          data.buygiftlist = JSON.stringify(that.buygiftlist_submit)
        }

        if (that.$route.query.np == 1) {
          data.couponsid = couponsid
          data.integernumber = integernumber
          data.integermoney = integermoney
        } else if (
          that.$route.query.yl == 1 &&
          that.$route.query.actid != 1 &&
          that.$route.query.prize != 1 &&
          that.$route.query.mtact != 1
        ) {
          data.skuid =
            skuids.join() + (recommendskuids.length > 0 ? ',' + recommendskuids.join() : '')
          if (that.$route.query.acttype == 'hc_welfare') {
            data.ck_utoken = sessionStorage.getItem('ck_utoken')
          }
        } else if (that.$route.query.yl == 1 && that.$route.query.actid) {
          data.actid = that.$route.query.actid
        } else if (that.$route.query.ylact == 1) {
          data.skuid =
            skuids.join() + (recommendskuids.length > 0 ? ',' + recommendskuids.join() : '')
          data.activityid = shopConfirmResult.activityid ? shopConfirmResult.activityid : ''
        } else if (that.$route.query.ms == 1) {
          data.skuid =
            skuids.join() + (recommendskuids.length > 0 ? ',' + recommendskuids.join() : '')
          data.limitid = shopConfirmResult.limitid
        } else if (that.$route.query.prize == 1) {
          if (shopConfirmResult.actprizeid) {
            data.actprizeid = shopConfirmResult.actprizeid
          } else {
            data.prizeids = shopConfirmResult.prizeidArr ? shopConfirmResult.prizeidArr.join() : ''
          }
        } else {
          data.couponsid = couponsid
          data.integernumber = integernumber
          data.integermoney = integermoney
          data.communityid =
            shopConfirmResult.communityid != undefined ? shopConfirmResult.communityid : ''
          data.giftactid = that.giftactid
          data.giftitem = that.giftitem
          data.giftnum = that.giftnum
          if (that.$route.query.isexchange == 1 || shopConfirmResult.act_class == 'exchangebuy') {
            data.exchangeorderid = data.orderid
            delete data.orderid
          } else if (shopConfirmResult.act_class == 'allchangebuy') {
            data.allorderid = data.orderid
            delete data.orderid
          }
        }
        data.prodcouponid = that.productgify != null ? that.productgify.id : ''
        if (len == 0 || (len == list.length && that.addressVal.cardno != '')) {
          that.$toast.loading({
            mask: false,
            message: '正在提交',
            forbidClick: true,
            duration: 0
          })

          let shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
          if (shopConfirmResult.shareOpenid) {
            data.shareOpenid = shopConfirmResult.shareOpenid
          }

          if (shopConfirmResult.recommendId) {
            data.fastcartid = shopConfirmResult.recommendId
            if (shopConfirmResult.source) {
              data.source = shopConfirmResult.source
            }
          }
          if (shopConfirmResult) {
            shopConfirmResult.skuidArr = skuids
          }

          that.$customRequestAjax
            .post(url, data)
            .then(function (res) {
              if (res.data.code === 200) {
                // 埋点增加接口
                if (typeof that.$route.query.metro !== 'undefined') {
                  that.$clickburiedPoint({
                    data: {
                      actcode: that.$route.query.metro,
                      behavior: res.data.orderid,
                      userfrom: 0
                    },
                    url: 'ckysdatacenter/activity/save'
                  })
                }
                if (that.$route.query.acttype == 'hc_welfare') {
                  that.$toast.clear()
                  if (res.data.submitstatus == 1) {
                    that.$dialog
                      .confirm({
                        message: res.data.msg,
                        className: 'collect_button_alert',
                        cancelButtonColor: '#FC0324',
                        confirmButtonColor: '#FFFCFC',
                        confirmButtonText: '去看看',
                        cancelButtonText: '进入首页',
                        closeOnPopstate: true
                      })
                      .then(function () {
                        window.location.href = downloadpath
                      })
                      .catch(() => {
                        // on cancel
                        that.$router.replace('/')
                      })
                  } else {
                    that.$dialog
                      .alert({
                        message: res.data.msg,
                        className: 'percen_button_alert',
                        confirmButtonColor: '#FFFCFC',
                        confirmButtonText: '去进货',
                        closeOnPopstate: false
                      })
                      .then(function () {
                        window.location.href = downloadpath
                      })
                  }
                  return
                } else if (shopConfirmResult.isgiftbagbuy == 1) {
                  that.$toast.clear()
                  that.$dialog
                    .alert({
                      message: res.data.msg,
                      className: 'percen_button_alert',
                      confirmButtonColor: '#FFFCFC',
                      confirmButtonText: '返回购买',
                      closeOnPopstate: false
                    })
                    .then(function () {
                      history.go(-1)
                    })
                  return
                } else if (that.$route.query.newpersonact == 1) {
                  that.$toast.clear()
                  that.$router.replace({
                    path: '/orderdetails',
                    query: {
                      id: res.data.orderid
                    }
                  })
                  return
                }
                localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
                that.orderid = res.data.orderid
                that.jumplink = res.data.jumplink ? res.data.jumplink : ''

                let saveParams = {
                  orderid: that.orderid,
                  recitemid: recitemid.join()
                }
                if (shopConfirmResult.save_course_params) {
                  saveParams.course_params = shopConfirmResult.save_course_params.join()
                }
                that.$commonburiedPoint({
                  data: saveParams
                })
                that.dataCollection('submitProductSuccess')
                that.dataCollection('submitOrderSuccess')
                var url = that.$ajax.getPayInfo_URL
                that.$customRequestAjax(url).then(function (res) {
                  if (res.data.code === 200) {
                    that.isSwitch = res.data
                    that.$toast({
                      message: '提交成功',
                      icon: require('../../assets/images/succ.png')
                    })
                    if (isWeixin()) {
                      /* 支付风控 */
                      // let money = !isNaN(parseFloat(that.paymoney)) ? that.paymoney : 0
                      // if (money >= 0) {
                      //   that.showPayTemp = true
                      //   return
                      // }
                      if (
                        (res.data.web_swiftwxpay == 1 || res.data.web_wxpay == 1) &&
                        res.data.web_unionpay != 1
                      ) {
                        that.to_cash()
                      } else {
                        sessionStorage.setItem('pay_switch', JSON.stringify(res.data))
                        localStorage.removeItem('skuids')
                        localStorage.removeItem('buynum')
                        localStorage.removeItem('itemid')
                        that.$router.replace({
                          path: '/pay',
                          query: {
                            id: that.orderid,
                            money: !isNaN(parseFloat(that.pay_money)) ? that.pay_money : 0,
                            yl: that.$route.query.yl || 0,
                            ms: that.$route.query.ms || 0,
                            lb: that.$route.query.lb || 0,
                            ylcc: that.$route.query.ylcc || 0,
                            ann: that.$route.query.ann || 0,
                            anncc: that.$route.query.anncc || 0,
                            ylact: that.$route.query.ylact || 0
                          }
                        })
                      }
                    } else {
                      sessionStorage.setItem('pay_switch', JSON.stringify(res.data))
                      localStorage.removeItem('skuids')
                      localStorage.removeItem('buynum')
                      localStorage.removeItem('itemid')
                      var arg = isApp()
                      if (arg == '') {
                        that.$router.replace({
                          path: '/pay',
                          query: {
                            id: that.orderid,
                            money: !isNaN(parseFloat(that.pay_money)) ? that.pay_money : 0,
                            yl: that.$route.query.yl || 0,
                            ms: that.$route.query.ms || 0,
                            lb: that.$route.query.lb || 0,
                            ylcc: that.$route.query.ylcc || 0,
                            ann: that.$route.query.ann || 0,
                            anncc: that.$route.query.anncc || 0,
                            ylact: that.$route.query.ylact || 0
                          }
                        })
                      } else {
                        var shopConfirmResult = JSON.parse(
                          localStorage.getItem('shopConfirmResult')
                        )
                        if (that.$route.query.yl == 1 || that.$route.query.ylact == 1) {
                          var obj = {
                            type: 'ylGoBuy',
                            itemid: shopConfirmResult.itemidArr.join(),
                            orderid: that.orderid,
                            ordermoney: !isNaN(parseFloat(that.pay_money)) ? that.pay_money : 0
                          }
                          window.ReactNativeWebView.postMessage(JSON.stringify(obj))
                        } else if (that.$route.query.ms == 1) {
                          var obj = {
                            type: 'msGoBuy',
                            orderid: that.orderid,
                            ordermoney: !isNaN(parseFloat(that.pay_money)) ? that.pay_money : 0
                          }
                          window.ReactNativeWebView.postMessage(JSON.stringify(obj))
                        }
                      }
                    }
                  }
                })
              } else if (res.data.code == 6001) {
                that.is_50vipentrance = 1
                that.mobile = ''
                that.code = ''
                that.sms = ''
              }
            })
            .catch(function (err) {
              that.$toast.fail('提交失败，请稍后重试')
            })
        } else if (len == list.length && that.addressVal.cardno == '') {
          that.$dialog
            .confirm({
              title: '完善信息',
              message: '您购买的商品为海外商品，需要实名认证后才可以购买',
              className: 'collect_button_alert',
              cancelButtonColor: '#FC0324',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '修改实名',
              cancelButtonText: '取消',
              closeOnPopstate: true
            })
            .then(function () {
              sessionStorage.setItem('oversea_List', JSON.stringify(list))
              var query = that.$route.query
              query.addressid = that.addressVal.id
              that.$router.replace({
                path: '/identity',
                query: query
              })
            })
        } else if (len < list.length && len > 0) {
          that.$toast('正常商品不可与海外商品同时购买')
        }
      }
    },
    isaddressFn: function () {
      var that = this,
        url =
          this.$ajax.checkAddress_URL +
          '?addressid=' +
          this.addressVal.id +
          '&payMoney=' +
          this.pay_money
      return new Promise(function (resolve, reject) {
        that
          .$customRequestAjax(url)
          .then(function (res) {
            that.isareacode =
              res.data.isareacode == 0 || res.data.isareacode == 1 ? res.data.isareacode : -1
            if (res.data.code == 200) {
              resolve(res)
            } else {
              reject(res)
            }
          })
          .catch(function (err) {
            resolve(err)
          })
      })
    },
    dataCollection(type) {
      let params
      if (type == 'submitOrderSuccess' || type == 'orderPaySuccess') {
        // 订单提交成功&订单支付成功
        let coupon = JSON.parse(sessionStorage.getItem('choose_coupon')),
          couponName = ''
        if (coupon && coupon.couponname) {
          couponName = coupon.couponname
        }
        params = {
          orderId_var: this.orderid, // 订单id
          actualPayment_var:
            parseFloat(this.totalprice) + parseFloat(this.freight) + parseFloat(this.giftmoney), // 实际支付金额
          payMethod_var: '微信支付', // 支付方式
          ifCouponUsed_var: this.couponsid ? '是' : '否', // 是否使用现金券
          couponType_var: '', // 现金券类型
          couponName_var: couponName, // 现金券名称
          orderAddress_var: this.addressVal.area // 订单收货城市
        }

        if (type == 'submitOrderSuccess') {
          delete params.payMethod_var
        }
        gio('track', type, params)
      } else {
        let list = this.list
        for (let i in list) {
          params = {
            orderId_var: this.orderid, // 订单id
            productId_var: list[i].itemid, // 商品id
            productName_var: list[i].name, // 商品名称
            firstCat_var: '', // 商品一级分类
            productType_var: '', // 商品品类
            productFormat_var: list[i].skuid, // 商品规格
            buyQuantity_var: list[i].num, // 购买数量
            payAmount_var: (list[i].price * list[i].num).toFixed(2) // 支付金额
          }

          gio('track', type, params)
        }
      }
    },
    address: function () {
      var query = this.$route.query
      query.addressid = this.addressVal.id
      query.type = 'submitorder'
      this.$router.push({
        path: '/addresschoose',
        query: query
      })
    },
    editaddressFn: function () {
      var query = this.$route.query
      query.type = 'addorder'
      query.ordertype = 'submitorder'
      query.id = this.addressVal.id
      this.$router.push({
        path: '/editadd',
        query: query
      })
    },
    addaddress: function () {
      var query = this.$route.query
      query.type = 'addorder'
      query.ordertype = 'submitorder'
      this.$router.push({
        path: '/addadd',
        query: query
      })
    },
    goChangebuy: function () {
      var skuids = [],
        itemnum = [],
        obj
      this.list.map((item) => {
        if (!item.ischangebuy) {
          skuids.push(item.skuid)
          itemnum.push(item.num)
        }
      })
      obj = {
        path: encryption(this.$route.fullPath),
        skuids: skuids.join(),
        itemnum: itemnum.join(),
        t: new Date().getTime()
      }
      // if (this.exchangeitemlist.length) {
      //   obj.isexchange = 1
      // }
      this.$router.push({
        path: '/productList',
        query: obj
      })
    },
    chooseCoupon: function (index) {
      var items = []
      var that = this
      that.usecouponlist.forEach(function (item, i) {
        if (i === index) {
          if (item.isChoose) {
            item.isChoose = false
            that.couponPrice = 0
            that.chooseUsecouponIndex = null
          } else {
            item.isChoose = true
            that.couponPrice = parseFloat(item.price).toFixed(2)
            that.chooseUsecouponIndex = i
          }
        } else {
          item.isChoose = false
        }
        items.push(item)
      })
      that.usecouponlist = items
    },
    showCouponDesc: function (index, type) {
      var couponShowList = []
      var nocouponShowList = []
      if (type == 'coupon') {
        this.usecouponlist.map(function (item, i) {
          if (index == i) {
            item.isShowDesc = !item.isShowDesc
          }
          couponShowList.push(item)
        })
        this.usecouponlist = couponShowList
      } else if (type == 'nocoupon') {
        this.nousercouponlist.map(function (item, i) {
          if (index == i) {
            item.isShowDesc = !item.isShowDesc
          }
          nocouponShowList.push(item)
        })
        this.nousercouponlist = nocouponShowList
      }
    },
    comfrimCoupon: function () {
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      shopConfirmResult.init_coupon_data = 1 // 自动匹配可用现金券数据 0用户未选择，需匹配； 1用户主动已选择，不匹配
      localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      this.showcoupon = false
      var coupon = this.usecouponlist[this.chooseUsecouponIndex]
      if (coupon != undefined && coupon != '' && coupon != null) {
        this.localCoupon = coupon
        this.localCoupon.checked = this.couponChecked
        this.couponPrice = this.localCoupon.price
        sessionStorage.setItem('choose_coupon', JSON.stringify(this.localCoupon))
      } else {
        this.couponstitle = ''
        this.localCoupon = null
        sessionStorage.removeItem('choose_coupon')
      }
      this.totalMoney()
      this.getjifen()
      this.loadcoupons()
      this.checkProduct()
    },
    // comfrimIntegral: function () {
    //   this.showintegral = false
    //   this.saveIntegral(this.integralChecked, 0)
    // },
    totalMoney: function () {
      // 实付金额计算
      if (
        sessionStorage.getItem('choose_coupon') &&
        this.couponChecked &&
        sessionStorage.getItem('choose_integral')
      ) {
        var coupon = JSON.parse(sessionStorage.getItem('choose_coupon'))
        var integral = JSON.parse(sessionStorage.getItem('choose_integral'))
        this.couponmoney = parseFloat(coupon.price)
        this.integralmoney = parseFloat(integral.integermoney)
        this.couponstitle = coupon.couponname + ' ￥' + parseFloat(coupon.price)
        this.totalprice =
          parseFloat(this.totalmoney) -
          parseFloat(coupon.price) -
          parseFloat(integral.checked ? parseFloat(integral.integermoney) : 0)
      } else if (sessionStorage.getItem('choose_integral')) {
        var integral = JSON.parse(sessionStorage.getItem('choose_integral'))
        this.integralmoney = parseFloat(integral.integermoney)
        this.couponmoney = 0
        this.totalprice =
          parseFloat(this.totalmoney) -
          parseFloat(integral.checked ? parseFloat(integral.integermoney) : 0)
        // this.couponstitle = ''
      } else if (sessionStorage.getItem('choose_coupon') && this.couponChecked) {
        var coupon = JSON.parse(sessionStorage.getItem('choose_coupon'))
        this.couponmoney = parseFloat(coupon.price)
        this.integralmoney = 0
        this.couponstitle = coupon.couponname + ' ￥' + parseFloat(coupon.price)
        this.totalprice = this.totalmoney - parseFloat(coupon.price)
      } else {
        this.couponmoney = 0
        this.integralmoney = 0
        this.totalprice = this.totalmoney
        // this.couponstitle = ''
      }
      this.giftruleCalculate()
      /**
       * activity: 38预约活动商品
       * cteatetime: 20230216
       * creater: gao en hui
       * scene：现金券场景~参与活动的商品一定参与现金券抵扣
       * */
      if (this.subscribegoodsrule && Object.keys(this.subscribegoodsrule).length > 0) {
        this.subscribegoodsRule()
      }
    },
    totalPrice: function (total, coupon, other) {
      // 优惠金额计算
      var money = parseFloat(total) + parseFloat(coupon || 0) - parseFloat(other || 0)
      return parseFloat(money)
    },
    subscribegoodsRule() {
      var coupon_money =
        sessionStorage.getItem('choose_coupon') && this.couponChecked
          ? parseFloat(JSON.parse(sessionStorage.getItem('choose_coupon')).price)
          : 0
      var integral_money = sessionStorage.getItem('choose_integral')
        ? parseFloat(JSON.parse(sessionStorage.getItem('choose_integral')).integermoney)
        : 0

      this.subscribegoodsrule.tips = ''
      if (
        this.subscribegoods_totalmoney - coupon_money - integral_money >=
        parseFloat(this.subscribegoodsrule.paymoney)
      ) {
        this.subscribegoodslist = Object.keys(this.subscribegoodsrule.goods).length
          ? [this.subscribegoodsrule.goods]
          : []
      } else {
        let m = parseFloat(
          parseFloat(this.subscribegoodsrule.paymoney) -
            (this.subscribegoods_totalmoney - coupon_money - integral_money)
        ).toFixed(2)
        if (m < parseFloat(this.subscribegoodsrule.paymoney)) {
          this.subscribegoodsrule.tips = '还差' + m + '元可带走已预约的<br/>保龄霜5g哦'
        }
        this.subscribegoodslist = []
      }
    },
    goBack: function () {
      // 个人中心进入返回上一级，支付后进入返回首页
      if (this.$route.query.route) {
        this.$router.replace({ path: '/' })
      } else {
        history.go(-1)
      }
    },
    /*
     * 微信支付
     */
    to_cash: function () {
      var url = this.$ajax.check_order_status_URL
      var data = {
        oid: this.orderid
      }
      var that = this
      that.$customRequestAjax.post(url, data).then(function (res) {
        if (res.data && res.data.code == 200) {
          if (res.data.order_status == 1 || res.data.order_status == 2) {
            var phpUrl
            if (that.isSwitch.web_wxpay == '1' && that.isSwitch.web_swiftwxpay == '1') {
              phpUrl = that.$ajax.weixin_wxpay2_URL
              if (that.isSwitch.wx_paytype == 1) {
                phpUrl = that.$ajax.weixinnet_wxpay2_URL
              }
            } else if (that.isSwitch.web_wxpay == '1') {
              phpUrl = that.$ajax.weixin_wxpay2_URL
              if (that.isSwitch.wx_paytype == 1) {
                phpUrl = that.$ajax.weixinnet_wxpay2_URL
              }
            } else if (that.isSwitch.web_swiftwxpay == '1') {
              phpUrl = that.$ajax.swiftpass_pay_URL
            }
            var phpData = {
              openid: appid,
              orderId: that.orderid
            }
            that.$customRequestAjax.post(phpUrl, phpData).then(function (res) {
              if (res.data && res.data.code == 200) {
                that.$toast.clear()
                if (that.isSwitch.web_wxpay == '1' && that.isSwitch.web_swiftwxpay == '1') {
                  that.callpay(JSON.parse(res.data.jsApiParameters))
                } else if (that.isSwitch.web_wxpay == '1') {
                  that.callpay(JSON.parse(res.data.jsApiParameters))
                } else if (that.isSwitch.web_swiftwxpay == '1') {
                  that.callpay(JSON.parse(res.data.codeinfo))
                }
              } else {
                that.$toast(res.data.codeinfo)
              }
            })
          } else {
            that.$toast(res.data.codeinfo)
            setTimeout(function () {
              that.$router.push('/')
            }, 1000)
          }
        }
      })
    },
    /*
     * 微信支付调用
     */
    callpay: function (d) {
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.jsApiCall, false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.jsApiCall)
          document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall)
        }
      } else {
        this.jsApiCall(d)
      }
    },
    /*
     * 调用微信JS api 支付
     */
    jsApiCall: function (d) {
      var that = this,
        shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult')),
        skuids = ['1718', '1721', '2271', '2570']
      WeixinJSBridge.invoke('getBrandWCPayRequest', d, function (res) {
        WeixinJSBridge.log(res.err_msg)
        if (res.err_msg == 'get_brand_wcpay_request:ok') {
          // that.dataCollection('productPaySuccess')
          // that.dataCollection('orderPaySuccess')
          localStorage.removeItem('skuids')
          localStorage.removeItem('buynum')
          localStorage.removeItem('itemid')
          setTimeout(function () {
            for (let i = 0; i < skuids.length; i++) {
              if (shopConfirmResult.skuidArr.indexOf(skuids[i]) > -1) {
                that.isSwitch.jumplink = ''
                break
              }
            }
            if (that.isSwitch.jumplink) {
              window.location = that.isSwitch.jumplink
              return
            }
            if (that.jumplink) {
              window.location = that.jumplink
              return
            }
            that.$router.replace({
              path: '/payResult',
              query: {
                id: that.orderid,
                money: !isNaN(parseFloat(that.pay_money)) ? that.pay_money : 0,
                payresult: encodeURIComponent('success'),
                yl: that.$route.query.yl || 0,
                ylact: that.$route.query.ylact || 0,
                ms: that.$route.query.ms || 0,
                lb: that.$route.query.lb || 0,
                ylcc: that.$route.query.ylcc || 0,
                ann: that.$route.query.ann || 0,
                anncc: that.$route.query.anncc || 0
              }
            })
            // window.location.href = "myOrder.html"
          }, 1000)
        } else if (
          res.err_msg == 'get_brand_wcpay_request:cancel' ||
          res.err_msg == 'get_brand_wcpay_request:fail'
        ) {
          localStorage.removeItem('skuids')
          localStorage.removeItem('buynum')
          localStorage.removeItem('itemid')
          that.$router.replace({
            path: '/payResult',
            query: {
              id: that.orderid,
              payresult: encodeURIComponent('failure'),
              yl: that.$route.query.yl || 0,
              ylact: that.$route.query.ylact || 0,
              ms: that.$route.query.ms || 0,
              lb: that.$route.query.lb || 0,
              ylcc: that.$route.query.ylcc || 0,
              ann: that.$route.query.ann || 0,
              anncc: that.$route.query.anncc || 0
            }
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
@import '../../assets/common/css/productList.scss';
.container {
  padding-bottom: 0.6rem;
  .fraud {
    display: flex;
    align-items: center;
    background: #fefceb;
    margin: 0.1rem 0.11rem;
    padding: 0.08rem;
    border-radius: 0.04rem;
    img {
      width: 0.13rem;
      height: 0.16rem;
    }
    p {
      font-size: 0.13rem;
      font-weight: 400;
      color: rgba(249, 106, 14, 1);
      line-height: 0.17rem;
      margin-left: 0.06rem;
      margin-right: 0.08rem;
      flex: 1;
    }
  }
  .my_address {
    margin: 0.11rem;
    background: #fff;
    border-radius: 0.04rem;
    padding: 0.15rem 0;
    padding-left: 0.15rem;
    position: relative;
    display: flex;
    align-items: center;
    .my_main_address {
      font-size: 0.16rem;
      line-height: 0.22rem;
      color: #222222;
      font-weight: 600;
      display: flex;
      align-items: center;
      img {
        width: 0.2rem;
        height: 0.12rem;
        margin-left: 0.05rem;
      }
    }
    .addressML {
      margin-left: 0.1rem;
    }
    .address {
      font-size: 0.12rem;
      line-height: 0.17rem;
      color: #999;
      margin-top: 0.04rem;
      padding-right: 0.3rem;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .van-icon-location-o {
      position: absolute;
      top: 0.35rem;
      left: 0.17rem;
      font-size: 0.19rem;
    }
    .addressicon {
      width: 0.18rem;
      height: 0.2rem;
      flex-shrink: 0;
    }
    .van-icon-arrow {
      position: absolute;
      top: 0.35rem;
      right: 0.15rem;
      font-size: 0.16rem;
      color: #1d1e1e;
    }
  }
  .no_address {
    padding: 0.13rem 0.15rem;
    background: rgba(255, 255, 255, 1);
    border-radius: 0.04rem;
    font-size: 0;
    margin: 0.11rem;
    .van-icon-plus {
      font-size: 0.15rem;
      line-height: 0.21rem;
      color: rgba(29, 30, 30, 1);
      top: 0.02rem;
    }
    p {
      display: inline-block;
      font-size: 0.15rem;
      font-weight: 400;
      color: rgba(29, 30, 30, 1);
      line-height: 0.21rem;
      margin-left: 0.08rem;
    }
  }
  .cart_pro_list {
    border-radius: 0.04rem;
    background: #fff;
    margin: 0.1rem 0.11rem;
    padding: 0.1rem 0.15rem 0;
    .list {
      padding-bottom: 0.2rem;
      font-size: 0.14rem;
      position: relative;
    }
    .productList {
      margin: 0;
      .item {
        padding: 0.16rem 0 0;
      }
    }
    .list:after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: 0;
      bottom: 0;
      left: 0;
      border-bottom: 1px solid #d8d8d8;
      transform: scaleY(0.5);
    }
    .numtotal {
      font-size: 0.12rem;
      line-height: 0.44rem;
      text-align: right;
      color: #3d3d3d;
      .totalprice {
        color: #222222;
        font-size: 0.16rem;
      }
    }
    &.recommenditemlist {
      .title {
        position: relative;
        img {
          width: 0.32rem;
          height: 0.15rem;
          margin-right: 0.08rem;
        }
        span {
          color: #333333;
          font-weight: bold;
        }
        .close {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .item {
        img {
          margin-left: 0;
        }
      }
      .rightBox {
        position: relative;
        .recommendPrice {
          position: absolute;
          width: 100%;
          bottom: 0;
          left: 0;
          .currentPrice {
            font-size: 0;
          }
          .label {
            font-size: 0.12rem;
          }
          .price {
            font-size: 0.18rem;
            font-weight: bold;
          }
          .oldPrice {
            color: #999999;
            font-size: 0.12rem;
            margin-left: 0.03rem;
            text-decoration: line-through;
            font-weight: initial;
          }
        }
        .stepBox0 {
          color: #ff0001;
          border: 0.005rem solid #ff0001;
          border-radius: 0.14rem;
          padding: 0.03rem 0.09rem;
        }
      }
    }
  }
  .additional {
    border-radius: 0.04rem;
    background: #fff;
    margin: 0.1rem 0.11rem;
    /*padding: .15rem 0;*/
    overflow: hidden;
    .van-cell:not(:last-child)::after,
    .van-hairline--top-bottom::after {
      border: 0;
    }
    .van-cell__title {
      span {
        font-size: 0.12rem;
        white-space: nowrap;
      }
    }
    .txt {
      font-size: 0.12rem;
      color: #333333;
      flex: auto;
    }
    .cell {
      .van-cell__right-icon {
        font-size: 0.1rem;
        color: #222222;
        margin-left: 0.02rem;
      }
    }
    .integral {
      .integralTitle {
        flex: 17;
        color: #3d3d3d;
      }
      .integralVal {
        flex: auto;
      }
      .integralLab {
        /*margin-left: 0.65rem;*/
        color: #3d3d3d;
        white-space: nowrap;
        margin-top: 0;
        i {
          font-style: normal;
          /* 积分规则修改废弃(勿删)
          color: #4a90e2;
          */
          color: #ffb346;
          font-size: 0.11rem;
          line-height: 0.12rem;
          /*vertical-align: middle;*/
        }
      }
      .integralCurrent,
      .integralTotal {
        display: flex;
        align-items: center;
      }
      .integralTotal {
        &.grayCoupon {
          opacity: 0.6;
        }
        img {
          width: 0.16rem;
          height: 0.16rem;
          margin-left: 0.02rem;
        }
        b {
          font-size: 0.12rem;
          font-weight: 400;
          margin-left: 0.31rem;
          line-height: 0.2rem;
          b {
            margin-left: 0;
            display: inline-block;
            color: #fc0324;
          }
        }
      }
    }
  }
  .additemMsg {
    bottom: 0.5rem;
  }
  .sub_bar {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 0.49rem;
    display: flex;
    align-items: center;
    font-size: 0.14rem;
    background: #fff;
    padding: 0.06rem 0.11rem 0;
    justify-content: space-between;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.25);
    .itemtxt {
      font-size: 0.12rem;
      color: #fc0324;
      width: 60%;
      margin-bottom: 0.06rem;
      .xprice {
        font-size: 0;
        /*line-height: .2rem;*/
      }
      b {
        font-size: 0.16rem;
        font-weight: 500;
      }
      sub {
        font-weight: normal;
        font-size: 0.12rem;
        vertical-align: baseline;
      }
      sup {
        font-size: 0.11rem;
        vertical-align: baseline;
        font-weight: 500;
      }
    }
    .btton {
      background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(255, 20, 79, 1) 100%);
      border-radius: 0.19rem;
      font-size: 0.16rem;
      width: 31%;
      line-height: 0.38rem;
      /*padding: .07rem .16rem;*/
      text-align: center;
      color: #fff;
      margin-bottom: 0.06rem;
    }
  }
  .coupon {
    /*padding-top: 0.53rem;*/
    padding-bottom: 0.73rem;
    .coupon_item {
      position: relative;
      &.nocoupon_item {
        .coupon_info {
          background: url('../../assets/images/coupon3.png') center center no-repeat;
          background-size: 100% 100%;
          .f1 {
            background: #f2f2f2;
          }
        }
      }
      &.product_item {
        .coupon_desc {
          border: solid 0.01rem #dddddd;
          border-top: none;
        }
      }
      .coupon_info {
        background: url('../../assets/images/couponbg.png') center center no-repeat;
        background-size: 100% 100%;
        min-height: 1.07rem;
        width: 3.45rem;
        margin: 0 auto;
        margin-top: 0.1rem;
        position: relative;
        &.isspecialbackground {
          background: url('../../assets/images/coupon4-1.png') center center no-repeat;
          background-size: 100% 100%;
          .f1 {
            span {
              color: #fff !important;
            }
            span:nth-child(1):before {
              color: #fff;
            }
          }
        }
        &.product_info {
          background: none;
          border: 0.01rem solid #dddddd;
          border-radius: 0.04rem;
          .productf1 {
            padding: 0;
            width: 30.5%;
            .product {
              width: 100%;
            }
          }
        }
        .f1 {
          /*background: #FBF1DF;*/
          font-size: 0.12rem;
          text-align: center;
          width: 29.2%;
          float: left;
          padding: 0 0.13rem;
          span:nth-child(1) {
            display: block;
            font-size: 0.36rem;
            color: #b1243d;
            font-weight: 600;
            line-height: 0.5rem;
            margin-top: 0.16rem;
            &:before {
              content: '￥';
              font-size: 0.15rem;
              font-weight: 600;
              color: rgba(177, 36, 61, 1);
              line-height: 0.21rem;
            }
          }
          span:nth-child(2) {
            color: #d43854;
            font-size: 0.13rem;
            text-align: center;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 0.74rem;
            display: block;
            margin-top: 0.06rem;
            line-height: 0.18rem;
          }
        }
        .f2 {
          float: left;
          position: relative;
          margin-left: 0.1rem;
          min-height: 1.07rem;
          width: 60%;
          /*overflow: hidden;*/
          span:nth-child(1) {
            display: block;
            font-size: 0.15rem;
            line-height: 0.21rem;
            color: #292929;
            font-weight: 400;
            margin-top: 0.23rem;
          }
          span:nth-child(2) {
            label {
              display: block;
              margin-top: -2%;
            }
            font-size: 0.1rem;
            line-height: 0.18rem;
            color: #6b6b6b;
            display: flex;
            margin-top: 0.08rem;
          }
        }
        .f3 {
          position: relative;
          top: -0.04rem;
          right: -0.14rem;
          font-size: 0.12rem;
          color: #fff;
          padding: 0.05rem 0;
          min-width: 0.6rem;
          text-align: center;
          background: #fc0324;
          border-radius: 0.14rem;
          height: 0.28rem;
          white-space: nowrap;
          border: 0.01rem solid #fc0324;
        }
        .f3.active {
          background: #dddddd;
          &.closeChoose {
            background: #ffffff;
            color: #fc0324;
          }
        }
        .coupon_tit {
          font-size: 0.12rem;
          color: #999999;
          left: 0;
          position: absolute;
          bottom: 0.05rem;
          width: 98%;
          padding-left: 29.2%;
          .tit_info {
            position: relative;
            padding-left: 0.1rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .tit {
              float: left;
              transform: scale(0.85);
              margin-left: -0.03rem;
              line-height: 0.14rem;
            }
            .van-icon {
              float: right;
              transform: scale(0.85);
            }
          }
        }
      }
      .coupon_desc {
        font-size: 0.12rem;
        line-height: 0.17rem;
        color: #848483;
        width: 3.45rem;
        margin: 0 auto;
        border: solid 1px rgba(237, 214, 173, 0.5);
        border-top: 0;
        padding: 0.06rem 0.1rem;
      }
    }
    .coupon_btn {
      width: 3.53rem;
      height: 0.43rem;
      background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
      border-radius: 0.25rem;
      text-align: center;
      font-size: 0.17rem;
      color: #fff;
      line-height: 0.43rem;
      margin: 0.1rem auto;
      margin-top: 0.2rem;
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      span {
        font-size: 0.13rem;
      }
    }
    &.integralPopUp {
      .van-radio {
        .van-radio__label {
          b {
            font-weight: 400;
            color: rgba(34, 34, 34, 1);
            font-size: 0.14rem;
            margin-right: 0.11rem;
            display: block;
          }
          i {
            font-style: normal;
            font-weight: 400;
            color: rgba(252, 3, 36, 1);
            font-size: 0.12rem;
            white-space: nowrap;
            display: block;
          }
        }
      }
    }
  }

  .coupon_name {
    padding: 0.17rem 0;
    font-size: 0.14rem;
    color: #222222;
    text-align: center;
    font-weight: 400;
    /*position: relative;*/
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    /*top: 10%;*/
    z-index: 10;
    transform: translateY(-0.11rem);
    background: #fff;
    img {
      position: absolute;
      right: 0.15rem;
      top: 0.17rem;
      width: 0.2rem;
      height: 0.2rem;
    }
  }
  .inegralAction {
    min-height: 60%;
  }
}
</style>
<style lang="scss">
.get_coupon_toast {
  padding: 0;
  width: 70%;
}
.addorder {
  .van-switch {
    height: 0.1rem;
    right: 0.02rem;
    &.van-switch--on {
      background: linear-gradient(270deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
      box-shadow: 0 0 0.04rem 0 rgba(238, 238, 238, 1);
      .van-switch__node {
        transform: translateX(0.22rem);
      }
    }
  }
  .van-switch__node {
    top: -0.05rem;
    left: 0;
    box-shadow: -0.03rem 0.01rem 0.04rem 0 rgba(91, 0, 0, 0.12);
    border: 0.01rem solid rgba(235, 235, 224, 1);
  }
  .van-popup {
    display: flex;
    flex-direction: column;
    .van-action-sheet__header {
      .van-action-sheet__close {
        background: url('../../assets/images/closex.png') no-repeat center;
        background-size: 0.2rem 0.2rem;
      }
    }
    .van-action-sheet__content {
      position: relative;
      /*flex: 1;*/
      overflow-y: auto;
    }
  }

  .van-action_model {
    height: 70vh;
    .van-item {
      padding: 0.14rem;
      .tit {
        font-size: 0.14rem;
        color: #262626;
        font-weight: 400;
        line-height: 0.23rem;
      }
      .con {
        padding-top: 0.1rem;
        line-height: 0.23rem;
        font-size: 0.13rem;
        color: #333333;
      }
    }
    .btn {
      padding: 0.14rem;
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      .vanbtn {
        width: 100%;
        height: 0.43rem;
        background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
        border-radius: 0.25rem;
      }
    }
  }
  .van-flod-dialog {
    width: 70%;
    &.temp_dialog {
      width: 80%;
      .floddialog {
        text-align: left;
      }
      .dialog-close {
        width: 0.2rem;
        height: 0.2rem;
        position: absolute;
        top: 0.06rem;
        right: 0.06rem;
      }
      .btn {
        /*justify-content: center;*/
        .van-btn-01,
        .van-btn-02 {
          white-space: nowrap;
        }
      }
      #launch-btn {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 3;
      }
    }
    &.van-address-dialog {
      width: 84%;
      .addressdialog {
        padding: 0.15rem 0.2rem 0;
        ul {
          li {
            margin-top: 0.15rem;
            overflow: hidden;
            width: 100%;
            color: #444444;
            font-size: 0.14rem;
            font-weight: 400;
            &.upd {
              margin-top: 0.1rem;
              > div {
                background: #f5f5f5;
                border-radius: 0.08rem;
                padding: 0.06rem 0.1rem;
              }
            }
            > span {
              width: 27%;
            }
            p {
              &.num,
              &.money {
                font-weight: 600;
              }
              &.money {
                color: #fc0324;
              }
            }
          }
        }
      }
    }
    .floddialog {
      padding: 0.3rem 0.1rem;
      padding-bottom: 0.1rem;
      text-align: center;
      font-size: 0.14rem;
      line-height: 0.2rem;
    }
    .btn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.22rem 0.19rem;
      &.areacodebtn {
        justify-content: center;
        .van-btn-02 {
          width: 60%;
        }
      }
      .van-btn-01,
      .van-btn-02 {
        width: 1.04rem;
        line-height: 0.32rem;
        height: 0.32rem;
        border-radius: 0.16rem;
      }
      .van-btn-01 {
        color: rgba(252, 3, 36, 1);
        border: 1px solid rgba(252, 3, 36, 1);
      }
      .van-btn-02 {
        background-color: #fc0324;
      }
    }
  }
}
.container .additional .field .van-cell__title {
  width: 0.72rem;
}
.container .additional .van-cell__title span {
  font-size: 0.12rem;
}
.container .additional .van-cell__value .van-field__control {
  font-size: 0.12rem;
  line-height: 0.25rem;
}
.container .additional .van-cell__value .van-field__control::placeholder {
  font-size: 0.12rem;
  line-height: 0.25rem;
}
.container .integralPopUp .van-radio-group {
  padding: 0 0.16rem;
}
.container .integralPopUp .van-radio-group .van-radio {
  margin-top: 0.17rem;
}
.container .integralPopUp .van-radio-group .van-radio:first-of-type {
  margin-top: 0;
}
.container .integralPopUp .van-radio .van-radio__label {
  display: flex;
  align-items: center;
}
.percen_button_alert.van-dialog.integral_button_alert {
  width: 80.67%;
}
.percen_button_alert.van-dialog.integral_button_alert .van-dialog__header {
  padding-top: 0.2rem;
}
.addorder
  .percen_button_alert.van-dialog.integral_button_alert
  .van-dialog__content
  .van-dialog__message {
  text-align: left;
}
.inegralAction {
  .van-action-sheet__header {
    height: 0.52rem;
    line-height: 0.52rem;
  }
  .van-hairline--bottom::after {
    border-bottom-width: 0;
  }
  .van-action-sheet__content {
    padding-top: 0.1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shopcart/addOrder.vue